import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config';
import Link from '@mui/material/Link';
import loadingGif from '../../assets/loading.gif';
import { useWebSocket } from '../ws/WebsocketContext';
import { ToastContainer, toast } from 'react-toastify';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import HomeIcon from '@mui/icons-material/Home';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import FormGroup from '@mui/material/FormGroup';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import AssignmentIcon from '@mui/icons-material/Assignment';
import WorkIcon from '@mui/icons-material/Work';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AddIcon from '@mui/icons-material/Add';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DialogContentText from '@mui/material/DialogContentText';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import JsBarcode from 'jsbarcode';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete'; // optimize

const OrderDetailDNP = () => {
  const { orderId } = useParams();
  const orgId = localStorage.getItem('selectedOrg');
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const socket = useWebSocket();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [updatePermission, setUpdatePermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [isAccessible, setIsAccessible] = useState(true);
  const [jobStepChanges, setJobStepChanges] = useState({});

  const [maxJobs, setMaxJobs] = useState(0);
  const [maxJobNotes, setMaxJobNotes] = useState(0);

  const [formModalVisible, setFormModalVisible] = useState(false);
  const [activeJobId, setActiveJobId] = useState(null);
  const [activeStepNumber, setActiveStepNumber] = useState(null);
  const [activeStepForms, setActiveStepForms] = useState([]);
  const [formValues, setFormValues] = useState({});

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmJobId, setConfirmJobId] = useState(null);
  const [confirmStepNumber, setConfirmStepNumber] = useState(null);
  const [confirmStepName, setConfirmStepName] = useState('');
  const [confirmJobName, setConfirmJobName] = useState('');
  
  const [expandedLogs, setExpandedLogs] = useState({});
  const [expandedScheduleLogs, setExpandedScheduleLogs] = useState({});
  const [jobFlowId, setJobFlowId] = useState(null);

  
  const [createScheduleDialogOpen, setCreateScheduleDialogOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState('');
  const [selectedStepId, setSelectedStepId] = useState('');
  const [scheduleTitle, setScheduleTitle] = useState('');
  const [scheduleLocation, setScheduleLocation] = useState('');
  const [scheduleNote, setScheduleNote] = useState('');
  const [scheduleAttendees, setScheduleAttendees] = useState('');
  const [scheduleStart, setScheduleStart] = useState('');
  const [scheduleEnd, setScheduleEnd] = useState('');
  const [scheduleEnabled, setScheduleEnabled] = useState(true);

  const [addNoteDialogOpen, setAddNoteDialogOpen] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');

  const [addJobDialogOpen, setAddJobDialogOpen] = useState(false);
  const [newJobName, setNewJobName] = useState('');
  const [newJobDescription, setNewJobDescription] = useState('');
  const [newJobUrgent, setNewJobUrgent] = useState(false);

  const [deleteJobDialogOpen, setDeleteJobDialogOpen] = useState(false);
  const [selectedDeleteJobId, setSelectedDeleteJobId] = useState('');
  const [deleteJobConfirmName, setDeleteJobConfirmName] = useState('');

  const [expandedFormLogs, setExpandedFormLogs] = useState({});

  const [selectedJobIdForNote, setSelectedJobIdForNote] = useState(null);


  const [editTagsDialogOpen, setEditTagsDialogOpen] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [editTagsState, setEditTagsState] = useState({
    urgent: false,
    completed: false,
    deleted: false,
    do_not_proceed: false,
  });


  const [editingPriceJobId, setEditingPriceJobId] = useState(null); // optimize
  const [editedPrice, setEditedPrice] = useState(''); // optimize
  const [editingNoteId, setEditingNoteId] = useState(null); // optimize
  const [editedNoteText, setEditedNoteText] = useState(''); // optimize
  const [noteToDelete, setNoteToDelete] = useState(null); // optimize
  const [editJobNameDialogOpen, setEditJobNameDialogOpen] = useState(false); // optimize
  const [editingJobName, setEditingJobName] = useState(''); // optimize
  const [editingJobForName, setEditingJobForName] = useState(null); // optimize
  const [scheduleColor, setScheduleColor] = useState(''); // optimize

  const [editingJobId, setEditingJobId] = React.useState(null);
  const [editedDescription, setEditedDescription] = React.useState('');

  const [allProductsDialogOpen, setAllProductsDialogOpen] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [editingJobProducts, setEditingJobProducts] = useState([]);
  const [currentEditingJobId, setCurrentEditingJobId] = useState(null);

  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [editedOrderDetails, setEditedOrderDetails] = useState({
    order_description: order?.order_description || '',
    quote: order?.quote || '',
    invoice_number: order?.invoice_number || '',
    purchase_order_number: order?.purchase_order_number || '',
    folder_path: order?.folder_path || '',
  });

  const [productSearchTerm, setProductSearchTerm] = React.useState('');
  const filteredProducts = allProducts.filter(product => {
    const search = productSearchTerm.toLowerCase();
    return (
      product.item_name.toLowerCase().includes(search) ||
      product.categoryName.toLowerCase().includes(search) ||
      product.departmentName.toLowerCase().includes(search)
    );
  });

  const [hasUpdateNotification, setHasUpdateNotification] = useState(false);

  // state for customers dialog
  const [customersDialogOpen, setCustomersDialogOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);

  // New state for add customer form
  const [addingCustomer, setAddingCustomer] = useState(false);
  const [customerType, setCustomerType] = useState('personal'); // 'personal' or 'company'

  // Personal customer fields
  const [personalCustomerName, setPersonalCustomerName] = useState('');
  const [personalCustomerEmail, setPersonalCustomerEmail] = useState('');
  const [personalCustomerNumber, setPersonalCustomerNumber] = useState('');

  // Company customer fields
  const [companyName, setCompanyName] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [companyNumber, setCompanyNumber] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');

  // Customer under company fields
  const [companyCustomerName, setCompanyCustomerName] = useState('');
  const [companyCustomerEmail, setCompanyCustomerEmail] = useState('');
  const [companyCustomerNumber, setCompanyCustomerNumber] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState('');

  const [expandedCompanies, setExpandedCompanies] = useState({}); // track expanded companies
  const [companyCustomersMap, setCompanyCustomersMap] = useState({}); // store fetched company customers keyed by companyId
  const [selectedCustomer, setSelectedCustomer] = useState(null); // { type: 'individual'|'company', customerId, companyId? }

  const [companyCustomersLoading, setCompanyCustomersLoading] = useState({}); // track loading per company
  const [individualSearchTerm, setIndividualSearchTerm] = useState('');
  const [companySearchTerm, setCompanySearchTerm] = useState('');

  const [addIndividualDialogOpen, setAddIndividualDialogOpen] = React.useState(false);
  const [addCompanyDialogOpen, setAddCompanyDialogOpen] = React.useState(false);
  const [addCompanyCustomerDialogOpen, setAddCompanyCustomerDialogOpen] = React.useState(false);
  const [companyForNewCustomer, setCompanyForNewCustomer] = React.useState(null);

  const [newIndividualCustomer, setNewIndividualCustomer] = React.useState({ customer_name: '', customer_email: '', customer_number: '' });
  const [newCompany, setNewCompany] = React.useState({ company_name: '', company_email: '', company_number: '', company_website: '' });
  const [newCompanyCustomer, setNewCompanyCustomer] = React.useState({ customer_name: '', customer_email: '', customer_number: '' });

  const [editedCustomerData, setEditedCustomerData] = React.useState({
    customerId: '',
    companyId: '',
    customerType: '', // 'individual' : 'company'
    customerName: '',
    customerNumber: '',
    customerEmail: '',
    companyName: '',
    companyNumber: '',
    companyEmail: '',
    companyWebsite: '',
  });
  const [editCustomerLoading, setEditCustomerLoading] = React.useState(false);
  const [editCustomerError, setEditCustomerError] = React.useState(null);

  const [holderName, setHolderName] = useState('Unknown User');


  // State for edit customer dialog
  const [editCustomerDialogOpen, setEditCustomerDialogOpen] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState(null); // object with customer info
  const [editCustomerType, setEditCustomerType] = useState(null); // 'individual' or 'company'
  const [editCustomerCompanyId, setEditCustomerCompanyId] = useState(null); // for company customers

  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const [addressForm, setAddressForm] = useState({
    street_address: order?.street_address || '',
    suburb: order?.suburb || '',
    state: order?.state || '',
    postal_code: order?.postal_code || '',
  });
  const [addressSaving, setAddressSaving] = useState(false);

  const [pricePermission, setPricePermission] = useState(false);
  const [showPrice, setShowPrice] = useState(false);
  const [reorderPermission, setReorderPermission] = useState(false);

  const handleOpenEditAddress = () => {
    setAddressForm({
      street_address: order?.street_address || '',
      suburb: order?.suburb || '',
      state: order?.state || '',
      postal_code: order?.postal_code || '',
    });
    setEditAddressOpen(true);
  };

  const handleUpdateJobPrice = async (jobId, newPrice) => { // optimize
    try {
      await axios.post(`${API_BASE_URL}/do-not-proceed/update-job-price`, {
        order_id: orderId,
        job_id: jobId,
        price: newPrice,
        order_prefix: order.order_prefix,
        order_number: order.order_number
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      toast.success('Job price updated successfully.');
      fetchOrder(); // refresh order data
    } catch (error) {
      toast.error('Failed to update job price. Please try again.');
      console.error('Error updating job price:', error);
    }
  };

  const handleUpdateNote = async (jobId, noteId, newText) => { // optimize
    try {
      await axios.post(`${API_BASE_URL}/do-not-proceed/update-job-note`, {
        order_id: orderId,
        job_id: jobId,
        job_note_id: noteId,
        note: newText,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
          userEmail: localStorage.getItem('userEmail'),
        },
      });
      
      toast.success('Note updated successfully.');
      fetchOrder();
      setEditingNoteId(null);
      setEditedNoteText('');
    } catch (error) {
      toast.error('Failed to update note. Please try again.');
      console.error('Error updating note:', error);
    }
  };

  const handleDeleteNote = async (jobId, noteId) => { // optimize
    try {
      await axios.post(`${API_BASE_URL}/do-not-proceed/delete-job-note`, {
        job_note_id: noteId,
        job_id: jobId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
          userEmail: localStorage.getItem('userEmail'),
        },
      });
      
      toast.success('Note deleted successfully.');
      fetchOrder();
      setNoteToDelete(null);
    } catch (error) {
      toast.error('Failed to delete note. Please try again.');
      console.error('Error deleting note:', error);
    }
  };

  const openEditJobNameDialog = (job) => { // optimize
    setEditingJobForName(job);
    setEditingJobName(job.job_name);
    setEditJobNameDialogOpen(true);
  };

  const handleEditJobNameSave = async () => { // optimize
    if (!editingJobForName) return;

    try {
      const payload = {
        order_id: order.order_id,
        job_id: editingJobForName.job_id,
        job_name: editingJobName,
      };

      await axios.post(`${API_BASE_URL}/orders/update-job-name`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
          userEmail: localStorage.getItem('userEmail'),
        },
      });

      toast.success('Job name updated successfully.');
      fetchOrder();

      setEditJobNameDialogOpen(false);
      setEditingJobForName(null);
      setEditingJobName('');
    } catch (error) {
      toast.error('Failed to update job name. Please try again.');
      console.error('Error updating job name:', error);
    }
  };

  const handleDisableSchedule = async (logId) => { // OPTIMIZE
    try {
      await axios.post(`${API_BASE_URL}/do-not-proceed/disable-schedule`, { log_id: logId }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      toast.success('Schedule disabled successfully.');
      fetchOrder();
    } catch (error) {
      toast.error('Failed to disable schedule.');
      console.error('Error disabling schedule:', error);
    }
  };

  const handleCloseEditAddress = () => {
    setEditAddressOpen(false);
  };

  const handleAddressChange = (field) => (event) => {
    setAddressForm(prev => ({ ...prev, [field]: event.target.value }));
  };

  const handleSaveAddress = async () => {
    setAddressSaving(true);
    try {
      await axios.post(`${API_BASE_URL}/orders/update-address`, {
        order_id: order.order_id,
        street_address: addressForm.street_address,
        suburb: addressForm.suburb,
        state: addressForm.state,
        postal_code: addressForm.postal_code,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      toast.success('Address updated successfully.');
      setEditAddressOpen(false);
      fetchOrder(); // refresh order data
    } catch (error) {
      toast.error('Failed to update address. Please try again.');
      console.error('Error updating address:', error);
    } finally {
      setAddressSaving(false);
    }
  };

  // Open edit customer dialog with data
  const openEditCustomerDialog = (type, customer, companyId = null) => {
    if (type === 'individual') {
      setEditedCustomerData({
        customerId: customer.customer_id,
        companyId: null,
        customerType: 'individual',
        customerName: customer.customer_name || '',
        customerNumber: customer.customer_number || '',
        customerEmail: customer.customer_email || '',
        companyName: '',
        companyNumber: '',
        companyEmail: '',
        companyWebsite: '',
      });
    } else if (type === 'company') {
      setEditedCustomerData({
        customerId: customer.customer_id,
        companyId: companyId,
        customerType: 'company',
        customerName: customer.customer_name || '',
        customerNumber: customer.customer_number || '',
        customerEmail: customer.customer_email || '',
        companyName: companies.find(c => c.company_id === companyId)?.company_name || '',
        companyNumber: companies.find(c => c.company_id === companyId)?.company_number || '',
        companyEmail: companies.find(c => c.company_id === companyId)?.company_email || '',
        companyWebsite: companies.find(c => c.company_id === companyId)?.company_website || '',
      });
    }
    setEditCustomerError(null);
    setEditCustomerDialogOpen(true);
  };

  // Close edit customer dialog
  const closeEditCustomerDialog = () => {
    setEditCustomerDialogOpen(false);
    setEditCustomerData(null);
    setEditCustomerType(null);
    setEditCustomerCompanyId(null);
  };

  // Handle input changes in the edit form
  const handleEditCustomerChange = (field, value) => {
    setEditedCustomerData(prev => ({ ...prev, [field]: value }));
  };

  // Submit edited customer data to API
  const handleEditCustomerSave = async () => {
    setEditCustomerLoading(true);
    setEditCustomerError(null);

    try {
      const payload = {
        customerId: editedCustomerData.customerId,
        companyId: editedCustomerData.companyId,
        customerType: editedCustomerData.customerType,
        customerName: editedCustomerData.customerName,
        customerNumber: editedCustomerData.customerNumber,
        customerEmail: editedCustomerData.customerEmail,
        companyName: editedCustomerData.companyName,
        companyNumber: editedCustomerData.companyNumber,
        companyEmail: editedCustomerData.companyEmail,
        companyWebsite: editedCustomerData.companyWebsite,
      };

      const response = await axios.post(`${API_BASE_URL}/orders/update-customer`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

        setEditCustomerDialogOpen(false);
        toast.success('Customer updated successfully!');
        
        fetchCompanyCustomersAfterUpdate(editedCustomerData.companyId);
        fetchCustomers();
      } catch (error) {
        // Axios error response message extraction
        const message = error.response?.data?.message || error.message || 'Failed to update customer';
        setEditCustomerError(message);
        toast.error(message);
      } finally {
        setEditCustomerLoading(false);
      }
    };

    const [createCustomerDialogOpen, setCreateCustomerDialogOpen] = useState(false);
    const [customerTypeToCreate, setCustomerTypeToCreate] = useState('Individual'); // or 'Company'
    const [newCustomerData, setNewCustomerData] = useState({
      customer_name: '',
      customer_email: '',
      customer_number: '',
      company_name: '',
      company_number: '',
      company_email: '',
      company_website: '',
    });
    const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);

    // Handlers to open dialogs
    const openCreateCustomerDialog = (type) => {
      setCustomerTypeToCreate(type);
      setNewCustomerData({
        customer_name: '',
        customer_email: '',
        customer_number: '',
        company_name: '',
        company_number: '',
        company_email: '',
        company_website: '',
      });
      setCreateCustomerDialogOpen(true);
    };

    const closeCreateCustomerDialog = () => {
      setCreateCustomerDialogOpen(false);
      setDuplicateDialogOpen(false);
    };

    // Handle input changes for new customer form
    const handleNewCustomerChange = (field, value) => {
      setNewCustomerData(prev => ({ ...prev, [field]: value }));
    };

    // API calls
    const checkDuplicateCustomer = async (data) => {

      try {
        const res = await axios.post(`${API_BASE_URL}/orders/check-duplicates`, data, {
          headers: { Authorization: `Bearer ${token}`, selectedorg: orgId },
        });
        return res.data;
      } catch (error) {
        console.error('Error checking duplicates:', error);
        throw error;
      }
    };

    const createCustomer = async (data) => {
      try {
        const res = await axios.post(`${API_BASE_URL}/orders/create`, data, {
          headers: { Authorization: `Bearer ${token}`, selectedorg: orgId },
        });
        return res.data;
      } catch (error) {
        console.error('Error creating customer:', error);
        throw error;
      }
    };

    // Submit handler with duplicate check and confirmation
    const handleCreateCustomerSubmit = async () => {
      // Basic validation
      if (!newCustomerData.customer_name || !newCustomerData.customer_email || !newCustomerData.customer_number) {
        toast.error('Please fill in all required fields.');
        return;
      }
      if (customerTypeToCreate === 'Company') {
        if (!newCustomerData.company_name || !newCustomerData.company_number || !newCustomerData.company_email || !newCustomerData.customer_name || !newCustomerData.customer_email || !newCustomerData.customer_number) {
          toast.error('Please fill in all required company fields.');
          return;
        }
      }

      const payload = {
        customerType: customerTypeToCreate,
        contactName: newCustomerData.customer_name,
        contactNumber: newCustomerData.customer_number,
        contactEmail: newCustomerData.customer_email,
        companyName: newCustomerData.company_name,
        companyNumber: newCustomerData.company_number,
        companyEmail: newCustomerData.company_email,
        companyWebsite: newCustomerData.company_website,
      };

      try {
        const duplicateCheck = await checkDuplicateCustomer(payload);
        if (duplicateCheck.duplicates && duplicateCheck.duplicates.length > 0) {
          setDuplicateDialogOpen(true);
        } else {
          await createCustomerAfterConfirm(payload);
        }
      } catch {
        toast.error('Failed to check duplicates.');
      }
    };

    const createCustomerAfterConfirm = async (payload) => {
      try {
        const result = await createCustomer(payload);
        toast.success(result.message);
        closeCreateCustomerDialog();
        fetchCustomers();
      } catch {
        toast.error('Failed to create customer.');
      }
    };

    // Duplicate confirmation dialog handlers
    const handleCreateAnyway = () => {
      setDuplicateDialogOpen(false);
      const payload = {
        customerType: customerTypeToCreate,
        contactName: newCustomerData.customer_name,
        contactNumber: newCustomerData.customer_number,
        contactEmail: newCustomerData.customer_email,
        companyName: newCustomerData.company_name,
        companyNumber: newCustomerData.company_number,
        companyEmail: newCustomerData.company_email,
        companyWebsite: newCustomerData.company_website,
      };
      createCustomerAfterConfirm(payload);
    };

    const handleCancelDuplicate = () => {
      setDuplicateDialogOpen(false);
    };

    const openAddCompanyCustomerDialog = (company) => {
      setCompanyForNewCustomer(company);
      setAddCompanyCustomerDialogOpen(true);
    };
    const closeAddCompanyCustomerDialog = () => {
      setCompanyForNewCustomer(null);
      setAddCompanyCustomerDialogOpen(false);
    };

    const handleNewCompanyCustomerChange = (field, value) => {
      setNewCompanyCustomer(prev => ({ ...prev, [field]: value }));
    };

  const handleAddCompanyCustomerSubmit = async () => {
    if (!companyForNewCustomer) {
      toast.error('No company selected.');
      return;
    }
    if (!newCompanyCustomer.customer_name || !newCompanyCustomer.customer_email || !newCompanyCustomer.customer_number) {
      toast.error('Please fill all company customer fields.');
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/orders/create/${companyForNewCustomer.company_id}`, {
        customerName: newCompanyCustomer.customer_name,
        customerEmail: newCompanyCustomer.customer_email,
        customerNumber: newCompanyCustomer.customer_number,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Company customer added successfully!');
      fetchCompanyCustomersAfterUpdate(companyForNewCustomer.company_id);
      closeAddCompanyCustomerDialog();
    } catch (error) {
      toast.error('Failed to add company customer.');
      console.error('Error adding company customer:', error);
    }
  };

  // Fetch customers when dialog opens (split individual and companies)
  const fetchCustomers = async () => {
    setLoadingCustomers(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/customers/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      const allCustomers = res.data.customers || [];

      // Separate individual customers and companies (companies have company_id and no customer_id)
      const individuals = allCustomers.filter(c => c.customer_id);
      const companies = allCustomers.filter(c => c.company_id && !c.customer_id);

      setIndividualCustomers(individuals);
      setCompanies(companies);
    } catch (error) {
      toast.error('Failed to load customers.');
      console.error(error);
    } finally {
      setLoadingCustomers(false);
    }
  };

  // Fetch customers for a company on expand
  const fetchCompanyCustomers = async (companyId) => {
    if (companyCustomersMap[companyId]) return; // already fetched

    setCompanyCustomersLoading(prev => ({ ...prev, [companyId]: true }));
    try {
      const res = await axios.get(`${API_BASE_URL}/orders/company-customers/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      setCompanyCustomersMap(prev => ({ ...prev, [companyId]: res.data.customers || [] }));
    } catch (error) {
      toast.error('Failed to load company customers.');
      console.error(error);
    } finally {
      setCompanyCustomersLoading(prev => ({ ...prev, [companyId]: false }));
    }
  };

  const fetchCompanyCustomersAfterUpdate = async (companyId) => {

    setCompanyCustomersLoading(prev => ({ ...prev, [companyId]: true }));
    try {
      const res = await axios.get(`${API_BASE_URL}/orders/company-customers/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      setCompanyCustomersMap(prev => ({ ...prev, [companyId]: res.data.customers || [] }));
    } catch (error) {
      toast.error('Failed to load company customers.');
      console.error(error);
    } finally {
      setCompanyCustomersLoading(prev => ({ ...prev, [companyId]: false }));
    }
  };

  const toggleCompanyExpand = (companyId) => {
    setExpandedCompanies(prev => {
      const newExpanded = { ...prev, [companyId]: !prev[companyId] };
      if (newExpanded[companyId]) {
        fetchCompanyCustomers(companyId);
      }
      return newExpanded;
    });
  };

  const handleSelectCustomer = (type, customerId, companyId = null) => {
    setSelectedCustomer({ type, customerId, companyId });
  };

  // Add new states for separated customers
  const [individualCustomers, setIndividualCustomers] = useState([]);
  const [companies, setCompanies] = useState([]);

  const filteredIndividuals = individualCustomers.filter(cust =>
    cust.customer_name?.toLowerCase().includes(individualSearchTerm.toLowerCase()) ||
    cust.customer_email?.toLowerCase().includes(individualSearchTerm.toLowerCase())
  );

  const filteredCompanies = companies.filter(comp =>
    comp.company_name?.toLowerCase().includes(companySearchTerm.toLowerCase())
  );

  const openCustomersDialog = () => {
    setCustomersDialogOpen(true);
    fetchCustomers();
  };

  const closeCustomersDialog = () => {
    setCustomersDialogOpen(false);
    setAddingCustomer(false);
    // Reset form fields
    setCustomerType('personal');
    setPersonalCustomerName('');
    setPersonalCustomerEmail('');
    setPersonalCustomerNumber('');
    setCompanyName('');
    setCompanyEmail('');
    setCompanyNumber('');
    setCompanyWebsite('');
    setCompanyCustomerName('');
    setCompanyCustomerEmail('');
    setCompanyCustomerNumber('');
    setSelectedCompanyId('');
  };

  const toggleFormExpand = (formLogId) => {
    setExpandedFormLogs(prev => ({ ...prev, [formLogId]: !prev[formLogId] }));
  };

  let tempUpdatePermission = false;

  const fetchUserPermissions = async () => {
    const permissionsResponse = await axios.get(`${API_BASE_URL}/orders/current-order-permissions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      if (!permissionsResponse.data[0].do_not_proceed_read) {
        navigate('/unauthorized');
        return;
      }

      setUpdatePermission(permissionsResponse.data[0].do_not_proceed_update === 1);
      setDeletePermission(permissionsResponse.data[0].do_not_proceed_delete === 1);
      setPricePermission(permissionsResponse.data[0].product_management_read === 1);
      setReorderPermission(permissionsResponse.data[0].create_order === 1); 
      tempUpdatePermission = permissionsResponse.data[0].do_not_proceed_update === 1;
  }

  const fetchOrder = async () => {
    if (!token || !orgId) {
        navigate('/unauthorized');
        return;
    }
    
    try {
      const orderResponse = await axios.get(`${API_BASE_URL}/do-not-proceed/details/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      // Show toast if user has update permission but order is read-only
      if (orderResponse.data.readOnly) {
        const holder = orderResponse.data.sessionHolder;
        setHolderName(holder ? `${holder.firstName} ${holder.lastName}` : 'Unknown User');
        toast.info(`${holder ? `${holder.firstName} ${holder.lastName}` : 'Unknown User'} is currently on this order.`);
        setIsAccessible(false);
      }

      setOrder(orderResponse.data);
      // optimize V
      if (orderResponse.data.prefix && orderResponse.data.order_name) {
        document.title = `${orderResponse.data.prefix}${orderResponse.data.order_name} - DNP Order Detail - IMS`;
      } else {
        document.title = "DNP Order Detail - IMS";
      }
      // optimize A
      setJobFlowId(orderResponse.data.jobFlowId || null);

    } catch (error) {
      console.error('Error fetching order detail:', error);
      navigate('/unauthorized');
      return;
    }
  }

  const applySelectedCustomer = async () => {
    if (!selectedCustomer) return;

    const { type, customerId, companyId } = selectedCustomer;

    // Update local order state
    if (type === 'Individual') {
      const customer = individualCustomers.find(c => c.customer_id === customerId);
      if (customer) {
        setOrder(prev => ({
          ...prev,
          individual_customer_id: customer.customer_id,
          individual_customer_name: customer.customer_name,
          individual_customer_email: customer.customer_email,
          individual_customer_number: customer.customer_number,
          company_customer_id: null,
          company_customer_name: '',
          company_customer_email: '',
          company_customer_number: '',
        }));
      }
    } else if (type === 'Company') {
      const company = companies.find(c => c.company_id === customerId);
      if (company) {
        setOrder(prev => ({
          ...prev,
          company_customer_id: company.company_id,
          company_customer_name: company.company_name,
          company_customer_email: company.company_email,
          company_customer_number: company.company_number,
          individual_customer_id: null,
          individual_customer_name: '',
          individual_customer_email: '',
          individual_customer_number: '',
        }));
      }
    }

    // Post update to backend
    try {
      await axios.post(`${API_BASE_URL}/orders/update-order-customer`, {
        type: type.toLowerCase(), // 'individual' or 'company'
        customerId,
        orderId,
        companyId
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      toast.success('Order customer updated successfully.');
      await fetchOrder(orderId);
    } catch (error) {
      toast.error('Failed to update order customer.');
      console.error('Error updating order customer:', error);
    }

    closeCustomersDialog();
  };

  const fetchLimits = async () => {
    try {
      const [maxOrderJobsRes, notesLimitRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/orders/max-order-jobs`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        }),
        axios.get(`${API_BASE_URL}/orders/notes-limit`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        }),
      ]);

      setMaxJobs(maxOrderJobsRes.data || 0);
      setMaxJobNotes(notesLimitRes.data.max_job_note || 0);

    } catch (error) {
      console.error('Error fetching limits:', error);
    }
  }

  useEffect(() => { // optimize
    document.title = "DNP Order Detail - IMS";
    
    return () => {
      document.title = "IMS";
    };
  }, []);

  useEffect(() => {
    if (!isEditingDetails && order) {
      setEditedOrderDetails({
        order_description: order.order_description || '',
        quote: order.quote || '',
        invoice_number: order.invoice_number || '',
        purchase_order_number: order.purchase_order_number || '',
        folder_path: order.folder_path || '',
      });
    }
  }, [order, isEditingDetails]);

  const handleDetailsChange = (field, value) => {
    // Limit all fields except order_description to max 254 chars
    if (field !== 'order_description' && value.length > 254) return;
    setEditedOrderDetails(prev => ({ ...prev, [field]: value }));
  };

  const handleDetailsEditToggle = async () => {
    if (isEditingDetails) {
      try {
        // Send all 5 fields to order route regardless of changes
        await axios.post(`${API_BASE_URL}/orders/update-details`, {
          order_id: order.order_id,
          order_description: editedOrderDetails.order_description,
          quote: editedOrderDetails.quote,
          invoice_number: editedOrderDetails.invoice_number,
          purchase_order_number: editedOrderDetails.purchase_order_number,
          folder_path: editedOrderDetails.folder_path,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        toast.success('Order details updated successfully.');
        setIsEditingDetails(false);
        fetchOrder();
      } catch (error) {
        toast.error('Failed to update order details. Please try again.');
        console.error('Error updating order details:', error);
      }
    } else {
      setIsEditingDetails(true);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      setLoading(true);
      await fetchUserPermissions();
      await fetchOrder();
      await fetchLimits();
      setLoading(false);
    };

    initialize();
  }, [orgId, navigate]);

  // WebSocket subscription for order editing lock
  useEffect(() => {
    if (socket && orderId) {

      const subscribe = () => {
        try {
          socket.send(JSON.stringify({
            type: 'subscribe',
            channel: `order:${orderId}`
          }));
          console.log(`Subscribed to order:${orderId}`);
        } catch (error) {
          console.error('WebSocket subscription error:', error);
        }
      };

      subscribe();

      const handleMessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          if (message.channel === `order:${orderId}`) {
            const userName = localStorage.getItem('userName') || 'Unknown User'; 
            if (message.channel === `order:${orderId}`) {
            // Check if the message contains the user's own name
            if (!message.data.includes(userName)) {
              toast.info(message.data || 'Default message');
            }
          }
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      socket.addEventListener('message', handleMessage);

      return () => {
        try {
          socket.send(JSON.stringify({
            type: 'unsubscribe',
            channel: `order:${orderId}`
          }));
          console.log(`Unsubscribed from order:${orderId}`);
        } catch (error) {
          console.error('WebSocket unsubscription error:', error);
        }
        socket.removeEventListener('message', handleMessage);
      };
    }
  }, [socket, orderId]);

  useEffect(() => {
    if (socket && jobFlowId != null) {
      const channel = `jobflow:${jobFlowId}`;

      const subscribe = () => {
        try {
          socket.send(JSON.stringify({
            type: 'subscribe',
            channel: channel,
          }));
          console.log(`Subscribed to ${channel}`);
        } catch (error) {
          console.error('WebSocket subscription error:', error);
        }
      };

      const unsubscribe = () => {
        try {
          socket.send(JSON.stringify({
            type: 'unsubscribe',
            channel: channel,
          }));
          console.log(`Unsubscribed from ${channel}`);
        } catch (error) {
          console.error('WebSocket unsubscription error:', error);
        }
      };

      const handleMessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          if (message.channel === channel) {
            const userName = localStorage.getItem('userName') || 'Unknown User';
            if (!message.data.includes(userName)) {
              toast.info(message.data || 'Default message');

              // Check if message contains this order's name to trigger glow
              if (order.order_name && message.data.includes(order.order_name)) {
                setHasUpdateNotification(true);
              }
            }
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      subscribe();
      socket.addEventListener('message', handleMessage);

      return () => {
        unsubscribe();
        socket.removeEventListener('message', handleMessage);
      };
    }
  }, [socket, jobFlowId]);

  // Handler for clicking a step in the progress bar
  const handleStepClick = (jobId, stepNumber) => {
    if (!updatePermission || !isAccessible) return;

    const job = order.jobs.find(j => j.job_id === jobId);
    if (!job) return;

    const step = order.job_flow_steps.find(s => s.stepNumber === stepNumber);
    if (!step) return;

    if (step.forms && step.forms.length > 0) {
      // Show form modal for this step
      setActiveJobId(jobId);
      setActiveStepNumber(stepNumber);
      setActiveStepForms(step.forms);
      const initialValues = {};
      step.forms.forEach(form => {
        if (form.form_definition && form.form_definition.fields) {
          form.form_definition.fields.forEach(field => {
            initialValues[field.name] = field.type === 'boolean' ? false : '';
          });
        }
      });
      setFormValues(initialValues);
      setFormModalVisible(true);
    } else {
      // Open confirmation dialog for non-form steps
      setConfirmJobId(jobId);
      setConfirmStepNumber(stepNumber);
      setConfirmStepName(step.stepName);
      setConfirmJobName(job.job_name);
      setConfirmDialogOpen(true);
    }
  };

  async function handleAddNote() {
    if (!newNoteText.trim()) {
      alert('Please enter a note.');
      return;
    }

    try {
      const payload = {
        job_id: selectedJobIdForNote,
        note: newNoteText,
        order_id: orderId,
      };

      await axios.post(`${API_BASE_URL}/orders/add-job-note`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Note added successfully.');
      setAddNoteDialogOpen(false);
      setNewNoteText('');
    } catch (error) {
      toast.error('Failed to add note. Please try again.');
      console.error('Error adding note:', error);
    }
  }

  const [logTypeFilter, setLogTypeFilter] = useState({
    order: true,
    job: true,
    form: true,
    schedule: true,
  });
  const [jobFilter, setJobFilter] = useState([]);

// Prepare combined logs with type and job info
const combinedLogs = useMemo(() => {
  if (!order) return [];

  const logs = [];

  // Order logs
  if (order.order_logs) {
    order.order_logs.forEach(logItem => {
      logs.push({
        ...logItem,
        type: 'order',
        job_id: null,
        created_at: logItem.created_at,
      });
    });
  }

  // Job logs and form logs
  if (order.jobs) {
    order.jobs.forEach(job => {
      if (job.logs) {
        job.logs.forEach(logItem => {
          logs.push({
            ...logItem,
            type: 'job',
            job_id: job.job_id,
            job_name: job.job_name,
            created_at: logItem.created_at,
          });
        });
      }
      if (job.form_logs) {
        job.form_logs.forEach(formLog => {
          logs.push({
            ...formLog,
            type: 'form',
            job_id: job.job_id,
            job_name: job.job_name,
            created_at: formLog.created_at,
          });
        });
      }
      // Add schedules as logs
      if (job.job_schedules) {
        job.job_schedules.forEach(schedule => {
          logs.push({
            ...schedule,
            type: 'schedule',
            job_id: job.job_id,
            job_name: job.job_name,
            created_at: schedule.created_at,
          });
        });
      }
    });
  }

  // Sort descending by created_at, and for same timestamp order by type priority: job > form > schedule > order
  logs.sort((a, b) => {
    const dateDiff = new Date(b.created_at) - new Date(a.created_at);
    if (dateDiff !== 0) return dateDiff;

    const priority = { job: 4, form: 3, schedule: 2, order: 1 };
    return (priority[b.type] || 0) - (priority[a.type] || 0);
  });

  // Apply filters
  return logs.filter(log => {
    if (!logTypeFilter[log.type]) return false;
    if (log.type !== 'order' && jobFilter.length > 0 && !jobFilter.includes(log.job_id)) return false;
    return true;
  });
  }, [order, logTypeFilter, jobFilter]);


  // Handle log type filter change
  const handleLogTypeChange = (event) => {
    setLogTypeFilter(prev => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  // Handle job filter toggle
  const toggleJobFilter = (jobId) => {
    setJobFilter(prev => {
      if (prev.includes(jobId)) {
        return prev.filter(id => id !== jobId);
      } else {
        return [...prev, jobId];
      }
    });
  };

  const openCreateScheduleDialog = () => {
    if (order.jobs && order.jobs.length > 0) {
      setSelectedJobId(order.jobs[0].job_id);
      // default to first step of job_flow_steps if available
      setSelectedStepId(order.job_flow_steps.length > 0 ? order.job_flow_steps[0].id : '');
    }
    setScheduleTitle('');
    setScheduleLocation('');
    setScheduleNote('');
    setScheduleAttendees('');
    setScheduleStart('');
    setScheduleEnd('');
    setScheduleEnabled(true);
    setCreateScheduleDialogOpen(true);
  };

  const handleCreateScheduleCancel = () => {
    setCreateScheduleDialogOpen(false);
  };

  const handleCreateScheduleSubmit = async () => {
    // Validate required fields
    if (!selectedJobId || !selectedStepId || !scheduleTitle || !scheduleStart || !scheduleEnd) {
      alert('Please fill in all required fields.');
      return;
    }
    // Prepare attendees as array by splitting comma-separated string and trimming
    const attendeesArray = scheduleAttendees.split(',').map(a => a.trim()).filter(a => a);

    try {
      const response = await axios.post(`${API_BASE_URL}/orders/add-schedule`, {
        order_id: orderId,
        job_id: selectedJobId,
        job_flow_step_id: selectedStepId,
        title: scheduleTitle,
        location: scheduleLocation,
        note: scheduleNote,
        attendees: attendeesArray,
        start_datetime: scheduleStart,
        end_datetime: scheduleEnd
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Schedule created successfully.');
      setCreateScheduleDialogOpen(false);

      // Update local order state to include the new schedule
      const newSchedule = {
        id: response.data.scheduleId || response.data.id || null,
        job_flow_step_id: selectedStepId,
        title: scheduleTitle,
        location: scheduleLocation,
        note: scheduleNote,
        attendees: attendeesArray,
        start_datetime: scheduleStart,
        end_datetime: scheduleEnd,
        created_at: new Date().toISOString(),
      };

      setOrder(prevOrder => {
        if (!prevOrder) return prevOrder;
        const updatedJobs = prevOrder.jobs.map(job => {
          if (job.job_id === selectedJobId) {
            const updatedSchedules = job.job_schedules ? [...job.job_schedules, newSchedule] : [newSchedule];
            return { ...job, job_schedules: updatedSchedules };
          }
          return job;
        });
        return { ...prevOrder, jobs: updatedJobs };
      });

    } catch (error) {
      toast.error('Failed to create schedule. Please try again.');
      console.error('Error creating schedule:', error);
    }
  };


  // Icon by log type
  const getIconByType = (type) => {
    switch(type) {
      case 'order': return <WorkIcon style={{ color: '#a5d6a7' }} />;
      case 'job': return <AssignmentIcon style={{ color: '#90caf9' }} />;
      case 'form': return <DescriptionIcon style={{ color: '#f48fb1' }} />;
      case 'schedule': return <EventNoteIcon style={{ color: '#64b5f6' }} />;
      default: return null;
    }
  };

  // Format date/time nicely
  const formatDateTime = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleString();
  };

  // Confirmation dialog handlers
  const handleConfirmCancel = () => {
    setConfirmDialogOpen(false);
    setConfirmJobId(null);
    setConfirmStepNumber(null);
    setConfirmStepName('');
  };

  const handleConfirmOk = async () => {
    if (!confirmJobId || confirmStepNumber == null || !orderId) return;

    try {
      await axios.post(`${API_BASE_URL}/orders/update-job-step`, {
        order_id: orderId,
        job_id: confirmJobId,
        step_number: confirmStepNumber,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Job step updated successfully.');

      setJobStepChanges(prev => ({ ...prev, [confirmJobId]: confirmStepNumber }));

      // fetchOrder();
      window.location.reload();

    } catch (error) {
      toast.error('Failed to update job step. Please try again.');
      console.error('Error updating job step:', error);
    } finally {
      setConfirmDialogOpen(false);
      setConfirmJobId(null);
      setConfirmStepNumber(null);
      setConfirmStepName('');
    }
  };

  // Handle form input change
  const handleFormChange = (fieldName, value) => {
    setFormValues(prev => ({ ...prev, [fieldName]: value }));
  };

  // Validate form (simple required check)
  const validateForm = () => {
    for (const form of activeStepForms) {
      if (form.form_definition && form.form_definition.fields) {
        for (const field of form.form_definition.fields) {
          const val = formValues[field.name];
          if ((field.type !== 'boolean') && (val === '' || val === null || val === undefined)) {
            alert(`Please fill the "${field.label}" field.`);
            return false;
          }
        }
      }
    }
    return true;
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    try {
      // Prepare log object from formValues
      const log = { ...formValues };

      // Post form log to backend
      await axios.post(`${API_BASE_URL}/orders/add-form-log`, {
        jobId: activeJobId,
        formStepName: activeStepForms.length > 0 ? activeStepForms[0].step_name || activeStepForms[0].stepName || 'Step' : 'Step',
        log,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      // After successful form log, update job step to current step
      await axios.post(`${API_BASE_URL}/orders/update-job-step`, {
        order_id: order.order_id,
        job_id: activeJobId,
        step_number: activeStepNumber,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Form data saved and job step updated successfully.');

      // Update local order state to reflect step change
      setOrder(prevOrder => {
        if (!prevOrder) return prevOrder;
        const updatedJobs = prevOrder.jobs.map(job => {
          if (job.job_id === activeJobId) {
            return { ...job, current_step: activeStepNumber };
          }
          return job;
        });
        return { ...prevOrder, jobs: updatedJobs };
      });

      setFormModalVisible(false);
      setJobStepChanges(prev => ({ ...prev, [activeJobId]: activeStepNumber }));
      setActiveJobId(null);
      setActiveStepNumber(null);
      setActiveStepForms([]);
      setFormValues({});
    } catch (error) {
      toast.error('Failed to save form data or update job step. Please try again.');
      console.error('Error saving form data or updating job step:', error);
    }
  };

  // Handle form modal cancel
  const handleFormCancel = () => {
    setFormModalVisible(false);
    setActiveJobId(null);
    setActiveStepNumber(null);
    setActiveStepForms([]);
    setFormValues({});
  };

  const toggleScheduleExpand = (scheduleId) => {
    setExpandedScheduleLogs(prev => ({
      ...prev,
      [scheduleId]: !prev[scheduleId],
    }));
  };

  // Handler to open Add Job dialog
  const openAddJobDialog = () => {
    setNewJobName('');
    setNewJobDescription('');
    setNewJobUrgent(false);
    setAddJobDialogOpen(true);
  };

  const openAddNoteDialog = (jobId) => {
    setSelectedJobIdForNote(jobId);
    setNewNoteText('');
    setAddNoteDialogOpen(true);
  };


  // Handler to cancel Add Job dialog
  const handleAddJobCancel = () => {
    setAddJobDialogOpen(false);
  };

  // Handler to submit new job
  const handleAddJobSubmit = async () => {
    if (!newJobName.trim()) {
      alert('Please enter a job name.');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/orders/add-job`, {
        order_id: order.order_id,
        job_name: newJobName,
        urgent: newJobUrgent ? 1 : 0,
        job_description: newJobDescription,
        price: 0
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Job added successfully.');

      fetchOrder();

      setAddJobDialogOpen(false);
    } catch (error) {
      toast.error('Failed to add job. Please try again.');
      console.error('Error adding job:', error);
    }
  };

  // Open delete job dialog
  const openDeleteJobDialog = () => {
  setSelectedDeleteJobId(order.jobs.length > 0 ? order.jobs[0].job_id : '');
  setDeleteJobConfirmName('');
  setDeleteJobDialogOpen(true);
};

  // Cancel delete job dialog
  const handleDeleteJobCancel = () => {
    setDeleteJobDialogOpen(false);
  };

  // Confirm delete job
  const handleDeleteJobConfirm = async () => {
    const jobToDelete = order.jobs.find(job => job.job_id === selectedDeleteJobId);
    if (!jobToDelete) {
      alert('Please select a job to delete.');
      return;
    }
    if (deleteJobConfirmName !== jobToDelete.job_name) {
      alert('Job name does not match. Please type the exact job name to confirm.');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/orders/delete-job`, {
        orderId: order.order_id,
        jobId: selectedDeleteJobId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success(response.data.message || 'Job deleted successfully.');

      // Refresh order data to reflect deletion
      fetchOrder();

      setDeleteJobDialogOpen(false);
    } catch (error) {
      toast.error('Failed to delete job. Please try again.');
      console.error('Error deleting job:', error);
    }
  };

  const openEditTagsDialog = (job) => {
    setEditingJob(job);
    setEditTagsState({
      urgent: !!job.urgent,
      completed: !!job.completed,
      deleted: !!job.deleted,
      do_not_proceed: !!job.do_not_proceed,
    });
    setEditTagsDialogOpen(true);
  };

  const handleEditTagChange = (tag) => (event) => {
    setEditTagsState(prev => ({ ...prev, [tag]: event.target.checked }));
  };

  const handleEditTagsSave = async () => {
    if (!editingJob) return;

    try {
      const payload = {
        order_id: order.order_id,
        job_id: editingJob.job_id,
        urgent: editTagsState.urgent ? 1 : 0,
        completed: editTagsState.completed ? 1 : 0,
        deleted: editTagsState.deleted ? 1 : 0,
        do_not_proceed: editTagsState.do_not_proceed ? 1 : 0,
      };

      await axios.post(`${API_BASE_URL}/orders/update-job-tag`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Job tags updated successfully.');

      fetchOrder();

      setEditTagsDialogOpen(false);
      setEditingJob(null);
    } catch (error) {
      toast.error('Failed to update job tags. Please try again.');
      console.error('Error updating job tags:', error);
    }
  };

  
  const handleStatusTagClick = async (tagKey) => {
    if (!updatePermission) return;

    const currentValue = order[tagKey] === 1 ? 0 : 1;

    setOrder(prevOrder => ({
      ...prevOrder,
      [tagKey]: currentValue,
    }));

    try {
      await axios.post(`${API_BASE_URL}/orders/update-tag`, {
        order_id: order.order_id,
        tag_key: tagKey,
        tag_value: currentValue,
        tag_name: order.tag_names?.[tagKey] || tagKey,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success(`Tag "${order.tag_names?.[tagKey] || tagKey}" updated successfully.`);
    } catch (error) {
      setOrder(prevOrder => ({
        ...prevOrder,
        [tagKey]: prevOrder[tagKey] === 1 ? 0 : 1,
      }));
      toast.error('Failed to update tag. Please try again.');
      console.error('Error updating tag:', error);
    }
  };

  const openEditProductsDialog = async (job) => {
    setCurrentEditingJobId(job.job_id);
    setEditingJobProducts(job.products || []);
    setAllProductsDialogOpen(true);
    setLoadingProducts(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/product/departments-with-products`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });
      const departments = response.data.departments || [];
      const productsList = [];
      departments.forEach(dept => {
        dept.categories.forEach(cat => {
          cat.items.forEach(item => {
            productsList.push({
              departmentName: dept.product_department_name,
              categoryName: cat.product_category_name,
              ...item,
            });
          });
        });
      });
      setAllProducts(productsList);
    } catch (error) {
      toast.error('Failed to load products.');
      console.error('Error loading products:', error);
    } finally {
      setLoadingProducts(false);
    }
  };

  const closeAllProductsDialog = () => {
    setAllProductsDialogOpen(false);
    setAllProducts([]);
    setEditingJobProducts([]);
    setCurrentEditingJobId(null);
  };

  const handleProductQuantityChange = (productId, quantity) => {
    setEditingJobProducts(prev => {
      const existing = prev.find(p => p.job_product_id === productId || p.product_item_id === productId);
      if (existing) {
        return prev.map(p => (p.job_product_id === productId || p.product_item_id === productId ? { ...p, quantity: Number(quantity) } : p));
      } else {
        // Add new product with quantity
        return [...prev, { product_item_id: productId, quantity: Number(quantity) }];
      }
    });
  };

  const saveJobProducts = async () => {
    try {
      const payload = {
        jobId: currentEditingJobId,
        products: editingJobProducts.map(p => ({
          product_item_id: p.product_item_id || p.job_product_id,
          quantity: p.quantity,
        })),
        orderId: order.order_id,
      };

      const res = await axios.post(`${API_BASE_URL}/orders/update-job-products`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Job products updated successfully.');
      fetchOrder();
      closeAllProductsDialog();
    } catch (error) {
      toast.error('Failed to update job products.');
      console.error('Error updating job products:', error);
    }
  };

  const handlePrintLabel = async () => {
    if (!order) return;

    let logoUrl = null;
    try {
      const res = await axios.get(`${API_BASE_URL}/org/get-org-logo/${orgId}`, {
        responseType: 'blob',
      });
      if (res.status === 200) {
        logoUrl = URL.createObjectURL(res.data);
      }
    } catch {
      // no logo or error, ignore
    }

    const canvas = document.createElement('canvas');
    JsBarcode(canvas, order.order_id, { format: 'CODE128', displayValue: true, height: 60 });
    const barcodeUrl = canvas.toDataURL('image/png');

    const userName = localStorage.getItem('userName') || 'Unknown User';
    const printedTime = new Date().toLocaleString();

    const company = order.company || {};
    const customer = order.customer || {};

    const htmlContent = `
      <html>
      <head>
        <title>Print Order Label</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 8px;
            margin: 0;
            color: #000;
            box-sizing: border-box;
          }
          .container {
            width: 300px;
            max-width: 300px;
            margin: auto;
            padding-bottom: 20px;
          }
          .header-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          }
          .logo {
            max-height: 40px;
            object-fit: contain;
            max-width: 120px;
          }
          .order-number {
            font-size: 1.4rem;
            font-weight: 700;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 8px;
            font-size: 0.75rem;
            color: #000;
          }
          th, td {
            border: 1px solid #000;
            padding: 3px 5px;
            text-align: left;
          }
          th {
            background-color: #fff;
            font-weight: 700;
            color: #000;
            font-size: 0.8rem;
          }
          td:first-child {
            width: 90px;
            min-width: 90px;
            max-width: 90px; 
          }
          .tag-check {
            color: #000;
            font-weight: 700;
            font-size: 0.9rem;
            line-height: 1;
            margin-right: 4px;
            vertical-align: middle;
          }
          .tag-cross {
            color: #000;
            font-weight: 700;
            font-size: 0.9rem;
            line-height: 1;
            margin-right: 4px;
            vertical-align: middle;
          }
          .address-line {
            font-size: 0.75rem;
            color: #000;
            margin-top: 3px;
          }
          .printed-info {
            text-align: center;
            font-size: 0.7rem;
            color: #000;
            margin-top: 6px;
            user-select: none;
          }
          .footer {
            text-align: center;
            font-size: 0.65rem;
            color: #000;
            margin-top: 10px;
            user-select: none;
            font-style: italic;
          }
          @media print {
            button.print-btn {
              display: none !important;
            }
            @page {
              size: 4in 6in;
              margin: 0.08in;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header-row">
            ${logoUrl ? `<img src="${logoUrl}" alt="Org Logo" class="logo" />` : '<div></div>'}
            <div class="order-number">${order.prefix}${order.order_name}</div>
          </div>

          <table>
            <thead>
              <tr><th colspan="2">Order Info</th></tr>
            </thead>
            <tbody>
              <tr><td>Quote</td><td>${order.quote || '-'}</td></tr>
              <tr><td>Invoice #</td><td>${order.invoice_number || '-'}</td></tr>
              <tr><td>PO #</td><td>${order.purchase_order_number || '-'}</td></tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr><th colspan="4">Tags</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>${order.tag_names?.tag1 || 'Tag 1'}</td>
                <td>${order.tag1 === 1 || order.tag1 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
                <td>${order.tag_names?.tag5 || 'Tag 5'}</td>
                <td>${order.tag5 === 1 || order.tag5 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
              </tr>
              <tr>
                <td>${order.tag_names?.tag2 || 'Tag 2'}</td>
                <td>${order.tag2 === 1 || order.tag2 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
                <td>${order.tag_names?.tag6 || 'Tag 6'}</td>
                <td>${order.tag6 === 1 || order.tag6 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
              </tr>
              <tr>
                <td>${order.tag_names?.tag3 || 'Tag 3'}</td>
                <td>${order.tag3 === 1 || order.tag3 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
                <td>${order.tag_names?.tag7 || 'Tag 7'}</td>
                <td>${order.tag7 === 1 || order.tag7 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
              </tr>
              <tr>
                <td>${order.tag_names?.tag4 || 'Tag 4'}</td>
                <td>${order.tag4 === 1 || order.tag4 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
                <td>${order.tag_names?.tag8 || 'Tag 8'}</td>
                <td>${order.tag8 === 1 || order.tag8 === '1' ? '<span class="tag-check">✓</span>' : '<span class="tag-cross">✗</span>'}</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr><th colspan="2">Company</th></tr>
            </thead>
            <tbody>
              ${company.company_name ? `
                <tr><td>Name</td><td><b>${company.company_name}</b></td></tr>
                <tr><td>Email</td><td>${company.company_email || '-'}</td></tr>
                <tr><td>Phone</td><td>${company.company_number || '-'}</td></tr>
              ` : `<tr><td colspan="2">N/A</td></tr>`}
            </tbody>
          </table>

          <table>
            <thead>
              <tr><th colspan="2">Customer</th></tr>
            </thead>
            <tbody>
              ${customer.customer_name ? `
                <tr><td>Name</td><td><b>${customer.customer_name}</b></td></tr>
                <tr><td>Email</td><td>${customer.customer_email || '-'}</td></tr>
                <tr><td>Phone</td><td>${customer.customer_number || '-'}</td></tr>
              ` : `<tr><td colspan="2">N/A</td></tr>`}
            </tbody>
          </table>

          <table>
            <thead>
              <tr><th>Address</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>${[order.street_address, order.suburb, order.state, order.postal_code].filter(Boolean).join(', ') || '-'}</td>
              </tr>
            </tbody>
          </table>

          <div class="printed-info">Printed by: ${userName} &nbsp;&bull;&nbsp; ${printedTime}</div>
        </div>

        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        </script>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'top=100,left=100');
    if (!printWindow) return;
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.focus();
    };

    if (loading) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 64px)',
          backgroundColor: '#fff',
        }}>
          <img src={loadingGif} alt="Loading..." style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
        </div>
      );
    }

    if (!order) return <div>Order not found.</div>;

  return (
    <div style={{ minHeight: 'calc(100vh - 64px)', padding: '10px', backgroundColor: '#f6f6f6', color: 'black' }}>
      <ToastContainer position="top-right" autoClose={10000} limit={5} />

      {/* Order and Status Section */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <button 
          onClick={() => navigate('/order/do-not-proceed')}
          style={{ 
            marginRight: '20px',
            border: '1px solid black',
            backgroundColor: 'transparent',
            color: 'black',
            padding: '6px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '36px'
          }}
          aria-label="Back"
        >
          <KeyboardReturnRoundedIcon />
        </button>

        {/* Order Name and Tags */}
        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h2 style={{ margin: 0, color: '#000000' }}>
            {order.prefix} {order.order_name}
          </h2>

          {/* Tags */}
          <div style={{ display: 'flex', gap: '8px' }}>
            {!updatePermission && (
              <span style={{
                backgroundColor: '#e0e0e0',
                color: '#000',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '0.85rem',
                userSelect: 'none'
              }}>
                Read Only
              </span>
            )}
            {!isAccessible && (
              <span style={{
                backgroundColor: '#ffc107',
                color: '#000',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '0.85rem',
                userSelect: 'none'
              }}>
                Order Reserved By <b>{holderName}</b>
              </span>
            )}
          </div>
        </div>
        {hasUpdateNotification &&
          <button 
            style={{ 
              border: '1px solid #007bff', 
              backgroundColor: 'transparent', 
              color: '#007bff', 
              padding: '6px 12px', 
              borderRadius: '4px', 
              cursor: 'pointer',
              height: '36px',
              marginRight: '10px'
            }}
            className={`refresh-button glow`}
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </button>
        }
        {
          reorderPermission && (
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => navigate(`/order/create-order/${order.order_id}`)}
              style={{ marginRight: '8px' }}
            >
              Reorder
            </Button>
          )
        }
        {
          pricePermission && (
            <Button 
              variant="contained" 
              color="secondary"
              onClick={() => setShowPrice(!showPrice)}
              style={{ marginRight: '8px' }}
            >
              {showPrice ? 'Hide Price' : 'Show Price'}
            </Button>
          )}

        {/* Print Label Button */}
        <button 
          style={{ 
            border: '1px solid #007bff', 
            backgroundColor: 'transparent', 
            color: '#007bff', 
            padding: '6px 12px', 
            borderRadius: '4px', 
            cursor: 'pointer',
            height: '36px',
            marginRight: '10px'
          }}
          onClick={handlePrintLabel}
        >
          Print Label
        </button>
      </div>

      <div style={{ display: 'flex', gap: '20px' }}>
        {/* Left column: 70% width */}
        <div style={{ flexBasis: '70%', flexGrow: 0, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Status box */}
          <div 
            style={{ 
              backgroundColor: 'white', 
              padding: '15px', 
              borderRadius: '6px', 
              boxShadow: '0 0 5px rgba(0,0,0,0.1)', 
              position: 'relative', 
              cursor: isAccessible && updatePermission ? 'pointer' : 'default',
              opacity: isAccessible ? 1 : 0.6, // visually indicate disabled
              userSelect: 'none',
            }}
          >
            <h3>Progress</h3>

            {/* Tags container with #f6f6f6 background */}
            <div style={{ backgroundColor: '#f6f6f6', padding: '10px', marginTop: '15px', borderRadius: '6px', display: 'flex', gap: '10px', flexWrap: 'nowrap' }}>
              {['tag1', 'tag2', 'tag3', 'tag4', 'tag5', 'tag6', 'tag7', 'tag8'].map(tagKey => {
                const tagName = order.tag_names?.[tagKey] || tagKey;
                const tagValue = order[tagKey];
                const isActive = tagValue === 1;
                return (
                  <div
                    key={tagKey}
                    style={{
                      backgroundColor: 'white',
                      color: isActive ? '#28a745' : '#888',
                      padding: '12px 0',
                      borderRadius: '8px',
                      flex: 1,
                      textAlign: 'center',
                      fontSize: '1rem',
                      userSelect: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: `1px solid ${isActive ? '#28a745' : '#ccc'}`,
                      transition: 'transform 0.3s ease',
                      cursor: isAccessible && updatePermission ? 'pointer' : 'default',
                    }}
                    onClick={isAccessible && updatePermission ? () => handleStatusTagClick(tagKey) : undefined}
                    onMouseEnter={e => {
                      if (isAccessible && updatePermission) e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={e => {
                      if (isAccessible && updatePermission) e.currentTarget.style.transform = 'scale(1)';
                    }}
                    role={isAccessible && updatePermission ? 'button' : undefined}
                    tabIndex={isAccessible && updatePermission ? 0 : undefined}
                    onKeyDown={e => {
                      if (isAccessible && updatePermission && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        handleStatusTagClick(tagKey);
                      }
                    }}
                    aria-pressed={isActive}
                    aria-label={`${isActive ? 'Disable' : 'Enable'} tag ${tagName}`}
                  >
                    {tagName}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Jobs box */}
          <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)', position: 'relative' }}>
              {/* Add buttons container at top right */}
              <div style={{ position: 'absolute', top: '15px', right: '15px', display: 'flex', gap: '10px' }}>
                {isAccessible && updatePermission && (
                  <button
                    onClick={openAddJobDialog}
                    disabled={order.jobs.length + (order.hidden_jobs_count || 0) >= maxJobs}
                    style={{
                      border: order.jobs.length + (order.hidden_jobs_count || 0) >= maxJobs ? '1px solid #ccc' : '1px solid #535353',
                      backgroundColor: order.jobs.length + (order.hidden_jobs_count || 0) >= maxJobs ? '#f0f0f0' : 'transparent',
                      color: order.jobs.length + (order.hidden_jobs_count || 0) >= maxJobs ? '#aaa' : '#535353',
                      padding: '6px 12px',
                      borderRadius: '4px',
                      cursor: order.jobs.length + (order.hidden_jobs_count || 0) >= maxJobs ? 'not-allowed' : 'pointer',
                      height: '32px',
                      fontSize: '0.85rem',
                      transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                    }}
                  >
                    Add Job
                  </button>
                )}
                {isAccessible && deletePermission && (
                  <button
                    onClick={openDeleteJobDialog}
                    style={{
                      border: '1px solid #dc3545',
                      backgroundColor: 'transparent',
                      color: '#dc3545',
                      padding: '6px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      height: '32px',
                      fontSize: '0.85rem',
                    }}
                  >
                    Delete Job
                  </button>
                )}
              </div>
            <h3>Do Not Proceed Jobs</h3>
            <h5 style={{ color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
              {order.hidden_jobs_count || 0} job(s) hidden
            </h5>

            {/* White box inside grey container */}
            <div style={{ backgroundColor: '#f6f6f6', borderRadius: '6px', padding: '15px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
              
              {order.jobs && order.jobs.length > 0 ? (
                 [...order.jobs]
                  .sort((a, b) => (b.urgent === 1) - (a.urgent === 1))
                  .map(job => {
                    const totalSteps = order.job_flow_steps.length;
                    const currentStepNumber = jobStepChanges[job.job_id] ?? job.current_step;

                // Helper to render status tags like urgent, completed, deleted, do_not_proceed

                const flashingStyle = {
                  animation: 'flash 1.5s infinite',
                  '@keyframes flash': {
                    '0%, 100%': { backgroundColor: '#ffc107' },
                    '50%': { backgroundColor: '#ffeb3b' },
                  }
                };

                const statusTags = [];
                if (job.urgent) statusTags.push({ label: 'URGENT', color: '#ff7f00' });
                if (job.completed) statusTags.push({ label: 'COMPLETED', color: '#28a745' });
                if (job.deleted) statusTags.push({ label: 'DELETED', color: '#6c757d' });
                if (job.do_not_proceed) statusTags.push({ 
                  label: 'DO NOT PROCEED', 
                  color: '#ffc107', 
                  textColor: '#000', 
                  flashing: true
                });

                return (
                  <>
                  <style>
                    {`
                      @keyframes flash {
                        0%, 100% { background-color: #ffc107; }
                        50% { background-color:rgb(255, 0, 0); }
                      }
                    `}
            </style>
          <div
            key={job.job_id}
            style={{
              borderRadius: '6px',
              padding: '15px',
              border: job.urgent ? '2px solid #ff7f00' : '1px solid #ddd',
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              gap: '15px'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h4 
                style={{ 
                  margin: 0, 
                  backgroundColor: '#d1e7dd',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontWeight: '600',
                  color: '#0f5132',
                  maxWidth: '100%',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  userSelect: 'text',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                }}
              >
                {job.job_name}
              </h4>
              {/* optimize V */}
              <div style={{ display: 'flex', gap: '8px' }}>
                {statusTags.map(({ label, color, textColor, flashing }) => (
                  <span
                    key={label}
                    style={{
                      backgroundColor: color,
                      color: textColor || '#fff',
                      padding: '6px 8px',
                      borderRadius: '12px',
                      fontSize: '0.75rem',
                      userSelect: 'none',
                      whiteSpace: 'nowrap',
                      ...(flashing ? {
                        animation: 'flash 1.5s infinite',
                      } : {})
                    }}
                  >
                    {label}
                  </span>
                ))}
                {isAccessible && updatePermission && (
                  <button
                    onClick={() => openEditJobNameDialog(job)}
                    style={{
                      marginLeft: '8px',
                      padding: '2px 8px',
                      fontSize: '0.75rem',
                      borderRadius: '4px',
                      border: '1px solid #28a745',
                      backgroundColor: 'transparent',
                      color: '#28a745',
                      cursor: 'pointer',
                      height: '24px',
                    }}
                    aria-label={`Edit name for job ${job.job_name}`}
                  >
                    Edit Job Name
                  </button>
                )}
                {isAccessible && updatePermission && (
                  <button
                    onClick={() => openEditTagsDialog(job)}
                    style={{
                      marginLeft: '8px',
                      padding: '2px 8px',
                      fontSize: '0.75rem',
                      borderRadius: '4px',
                      border: '1px solid #007bff',
                      backgroundColor: 'transparent',
                      color: '#007bff',
                      cursor: 'pointer',
                      height: '24px',
                    }}
                    aria-label={`Edit tags for job ${job.job_name}`}
                  >
                    Edit Job Status
                  </button>
                )}
                {editTagsDialogOpen && editingJob && (
                  <Dialog
                    open={editTagsDialogOpen}
                    onClose={() => setEditTagsDialogOpen(false)}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogTitle style={{ color: 'black' }}>Edit Job Status for {editingJob.job_name}</DialogTitle>
                    <DialogContent>
                      {['urgent', 'completed', 'do_not_proceed'].map(tag => (
                        <FormControlLabel
                          key={tag}
                          control={
                            <Checkbox
                              checked={editTagsState[tag]}
                              onChange={() => {
                                const isSelected = editTagsState[tag];
                                let newState = { urgent: false, completed: false, do_not_proceed: false };
                                if (!isSelected) {
                                  newState[tag] = true;
                                }
                                setEditTagsState(newState);
                              }}
                              color="primary"
                            />
                          }
                          label={tag.charAt(0).toUpperCase() + tag.slice(1).replace(/_/g, ' ')}
                        />
                      ))}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setEditTagsDialogOpen(false)}>Cancel</Button>
                      <Button onClick={handleEditTagsSave} variant="contained" color="primary">Save</Button>
                    </DialogActions>
                  </Dialog>
                )}
                {editJobNameDialogOpen && editingJobForName && (
                  <Dialog
                    open={editJobNameDialogOpen}
                    onClose={() => setEditJobNameDialogOpen(false)}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle style={{ color: 'black' }}>Edit Job Name</DialogTitle>
                    <DialogContent>
                      <TextField
                        autoFocus
                        margin="dense"
                        label="Job Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={1}
                        value={editingJobName}
                        onChange={(e) => setEditingJobName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleEditJobNameSave();
                          }
                        }}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setEditJobNameDialogOpen(false)}>Cancel</Button>
                      <Button onClick={handleEditJobNameSave} variant="contained" color="primary">Save</Button>
                    </DialogActions>
                  </Dialog>
                )}
                {
                  (job.price && showPrice) && (
                    editingPriceJobId === job.job_id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ opacity: 0.7 }}>Price:</span>
                        <input
                          type="number"
                          value={editedPrice}
                          onChange={(e) => setEditedPrice(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleUpdateJobPrice(job.job_id, editedPrice);
                              setEditingPriceJobId(null);
                              setEditedPrice('');
                            }
                            if (e.key === 'Escape') {
                              setEditingPriceJobId(null);
                              setEditedPrice('');
                            }
                          }}
                          autoFocus
                          style={{
                            width: '100px',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            border: '1px solid #c8e6c9',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            height: '24px',
                          }}
                        />
                        <button
                          onClick={() => {
                            handleUpdateJobPrice(job.job_id, editedPrice);
                            setEditingPriceJobId(null);
                            setEditedPrice('');
                          }}
                          disabled={!updatePermission}
                          style={{
                            padding: '2px 8px',
                            borderRadius: '4px',
                            border: '1px solid #2e7d32',
                            backgroundColor: '#2e7d32',
                            color: 'white',
                            cursor: 'pointer',
                            fontSize: '0.75rem',
                          }}
                        >
                          Save
                        </button>
                        <button
                          onClick={() => {
                            setEditingPriceJobId(null);
                            setEditedPrice('');
                          }}
                          style={{
                            padding: '2px 8px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            backgroundColor: 'white',
                            color: '#666',
                            cursor: 'pointer',
                            fontSize: '0.75rem',
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <span
                        onClick={() => {
                          if (isAccessible && updatePermission && pricePermission) {
                            setEditingPriceJobId(job.job_id);
                            setEditedPrice(job.price);
                          }
                        }}
                        style={{
                          backgroundColor: '#e8f5e9',
                          color: '#009c08',
                          padding: '2px 8px',
                          height: '24px',
                          borderRadius: '4px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          userSelect: 'none',
                          whiteSpace: 'nowrap',
                          border: '1px solid #c8e6c9',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          cursor: (isAccessible && updatePermission && pricePermission) ? 'pointer' : 'default',
                        }}
                      >
                        <span style={{ opacity: 0.7 }}>Price:</span>
                        ${typeof job.price === 'number' ? job.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : job.price}
                      </span>
                    )
                  )
                }
                {/* optimize A */}
              </div>
            </div>

            {/* Progress Bar with perfectly aligned nodes */}
              <div style={{ position: 'relative', height: '90px', cursor: (updatePermission && isAccessible) ? 'pointer' : 'default', userSelect: 'none' }}>
                {/* Colored bar with step colors and subtle shadow, narrower height */}
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '10px',
                    right: '10px',
                    height: '8px',
                    borderRadius: '4px',
                    background: `linear-gradient(to right, ${order.job_flow_steps.map(step => step.stepColor).join(', ')})`,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                    transform: 'translateY(-50%)',
                    zIndex: 0,
                  }}
                />

                {/* Step markers */}
                <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 2, height: '100%' }}>
                {order.job_flow_steps.map((step, index) => {
                  const isActive = step.stepNumber === currentStepNumber;
                  const isPast = step.stepNumber < currentStepNumber;
                  const isTopRow = index % 2 === 0;
                  const labelOffset = 20;
                  const nodeColor = isActive || isPast ? step.stepColor : '#bbb';
                  const borderColor = isActive || isPast ? step.stepColor : '#eee';
                  const borderWidth = 2;
                  const glow = isActive ? `0 0 12px 4px ${step.stepColor}, 0 0 24px 8px ${step.stepColor}66` : 'none';
                  // optimize V
                  return (
                    <div
                      key={step.id}
                      onClick={() => {
                        if (!updatePermission || !step.isAccessible) return;
                        handleStepClick(job.job_id, step.stepNumber);
                      }}
                      style={{
                        position: 'relative',
                        flex: '1 1 0',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: (updatePermission && step.isAccessible) ? 'pointer' : 'default',
                        transition: 'transform 0.2s ease',
                        opacity: step.isAccessible ? 1 : 0.6,
                      }}
                      title={step.stepName}
                      onMouseEnter={e => {
                        if (step.isAccessible && updatePermission) {
                          e.currentTarget.style.transform = 'scale(1.15)';
                        }
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <div style={{
                        maxWidth: '100px',
                        fontSize: '0.9rem',
                        color: step.isAccessible ? '#333' : '#bbb',
                        fontWeight: isActive ? '700' : '500',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        userSelect: 'none',
                        pointerEvents: 'none',
                        marginBottom: isTopRow ? `${labelOffset}px` : '0',
                        marginTop: isTopRow ? '0' : `${labelOffset + 40}px`,
                        order: isTopRow ? 0 : 2,
                        flexShrink: 0,
                        wordWrap: 'break-word',
                      }}>
                        {step.stepName}
                      </div>
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: nodeColor,
                        border: `${borderWidth}px solid ${borderColor}`,
                        transition: 'background-color 0.3s, border-color 0.3s, box-shadow 0.3s',
                        zIndex: 3,
                        order: 1,
                        boxShadow: glow,
                      }} />
                    </div>
                  );
                  // optimize A
                })}
                </div>
                </div>

                <div style={{ borderTop: '1px solid #ccc', margin: '15px 0' }} />

                {/* Three boxes horizontally aligned: Description, Products, Notes */}
                <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                  {/* Description box */}
                  <div style={{ flex: 1, backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '6px', minHeight: '100px', overflowY: 'auto', position: 'relative' }}>
                    <strong>Description</strong>
                    {editingJobId === job.job_id ? (
                      <>
                        <textarea
                          value={editedDescription}
                          onChange={e => setEditedDescription(e.target.value)}
                          autoFocus
                          style={{
                            marginTop: '5px',
                            width: '100%',
                            minHeight: '80px',
                            resize: 'vertical',
                            padding: '10px',
                            fontFamily: 'inherit',
                            fontSize: '0.9rem',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            boxSizing: 'border-box',
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                          }}
                        />
                        <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                          <button
                            onClick={async () => {
                              try {
                                await axios.post(`${API_BASE_URL}/orders/update-job-description`, {
                                  order_id: order.order_id,
                                  job_id: editingJobId,
                                  description: editedDescription,
                                }, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                    selectedorg: orgId,
                                  },
                                });
                                toast.success('Job description updated successfully.');
                                fetchOrder();
                                setEditingJobId(null);
                                setEditedDescription('');
                              } catch (error) {
                                toast.error('Failed to update job description. Please try again.');
                                console.error('Error updating job description:', error);
                              }
                            }}
                            style={{
                              padding: '6px 12px',
                              borderRadius: '4px',
                              border: 'none',
                              backgroundColor: '#007bff',
                              color: 'white',
                              cursor: 'pointer',
                            }}
                          >
                            Save
                          </button>
                          <button
                            onClick={() => {
                              setEditingJobId(null);
                              setEditedDescription('');
                            }}
                            style={{
                              padding: '6px 12px',
                              borderRadius: '4px',
                              border: '1px solid #ccc',
                              backgroundColor: 'white',
                              cursor: 'pointer',
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        {isAccessible && updatePermission && (
                          <button
                            onClick={() => {
                              setEditingJobId(job.job_id);
                              setEditedDescription(job.description || '');
                            }}
                            style={{
                              position: 'absolute',
                              top: '8px',
                              right: '8px',
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              padding: 0,
                              lineHeight: 1
                            }}
                            aria-label="Edit Job Description"
                          >
                            <EditOutlinedIcon />
                          </button>
                        )}
                        <div style={{
                          backgroundColor: '#ffffff',
                          padding: '10px',
                          borderRadius: '6px',
                          marginTop: '5px',
                          minHeight: '60px',
                          whiteSpace: 'pre-wrap',
                          fontSize: '0.9rem',
                          overflowWrap: 'break-word',
                        }}>
                          {job.description || 'No description'}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Products box */}
                  <div style={{ flex: 1, backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '6px', minHeight: '100px', overflow: 'hidden', position: 'relative' }}>
                    {isAccessible && updatePermission && (
                      <button
                        onClick={() => openEditProductsDialog(job)}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          lineHeight: 1
                        }}
                        aria-label="Edit Products"
                      >
                        <EditOutlinedIcon />
                      </button>
                    )}
                    <strong>Products</strong>
                    <div style={{
                      backgroundColor: 'white',
                      padding: '15px',
                      borderRadius: '6px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                      marginTop: '8px',
                      display: 'flex',
                      flexDirection: 'column',
                    }}>
                      {job.products && job.products.length > 0 ? (
                        <ul style={{ 
                          margin: 0, 
                          fontSize: '0.9rem', 
                          overflowY: 'auto', 
                          paddingLeft: 0, 
                          listStyle: 'none', 
                          display: 'flex', 
                          flexDirection: 'column', 
                          gap: '6px', 
                          flexGrow: 1 
                        }}>
                          {job.products
                            .filter(product => product.quantity > 0)
                            .map(product => (
                            <li 
                              key={product.job_product_id} 
                              style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center', 
                                padding: '6px 10px',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '6px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                userSelect: 'none',
                              }}
                            >
                              <span style={{ 
                                flexShrink: 1, 
                                whiteSpace: 'nowrap', 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                marginRight: '12px',
                              }}
                                title={product.item_name}
                              >
                                {product.item_name}
                              </span>
                              <span style={{ 
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                                fontWeight: '600',
                                userSelect: 'all',
                                textAlign: 'right',
                                minWidth: '70px',
                              }}>
                                {product.quantity} {product.unit_symbol || ''}
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p style={{ marginTop: '5px', fontSize: '0.9rem' }}>No products</p>
                      )}
                    </div>
                  </div>

                  {/* Notes box */}
                  <div style={{ flex: 1, backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '6px', minHeight: '100px', position: 'relative' }}>
                    <strong>Notes</strong>
                    {isAccessible && (
                      <button
                        onClick={() => openAddNoteDialog(job.job_id)}
                        disabled={job.notes && job.notes.length >= maxJobNotes}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          background: 'none',
                          border: 'none',
                          cursor: job.notes && job.notes.length >= maxJobNotes ? 'not-allowed' : 'pointer',
                          padding: 0,
                          lineHeight: 1,
                          opacity: job.notes && job.notes.length >= maxJobNotes ? 0.5 : 1,
                        }}
                        aria-label="Add Note"
                        title={job.notes && job.notes.length >= maxJobNotes ? `Maximum of ${maxJobNotes} notes reached` : "Add Note"}
                      >
                        <AddIcon />
                      </button>
                    )}
                    {/* optimize V */}
                      {job.notes && job.notes.length > 0 ? (
                        <div style={{ marginTop: '5px', display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                          {[...job.notes]
                            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // sort descending by created_at
                            .map(note => (
                              <div key={note.job_note_id} style={{
                                backgroundColor: 'white',
                                padding: '10px',
                                borderRadius: '6px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                userSelect: 'none',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px',
                              }}>
                                {editingNoteId === note.job_note_id ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <textarea
                                      value={editedNoteText}
                                      onChange={(e) => setEditedNoteText(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        fontSize: '0.9rem',
                                        minHeight: '80px',
                                        resize: 'vertical',
                                        userSelect: 'text',
                                      }}
                                      maxLength={255}
                                    />
                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                      <button
                                        onClick={() => {
                                          handleUpdateNote(job.job_id, note.job_note_id, editedNoteText);
                                        }}
                                        style={{
                                          padding: '4px 12px',
                                          borderRadius: '4px',
                                          border: '1px solid #28a745',
                                          backgroundColor: '#28a745',
                                          color: 'white',
                                          cursor: 'pointer',
                                          fontSize: '0.8rem',
                                        }}
                                      >
                                        Save
                                      </button>
                                      <button
                                        onClick={() => {
                                          setEditingNoteId(null);
                                          setEditedNoteText('');
                                        }}
                                        style={{
                                          padding: '4px 12px',
                                          borderRadius: '4px',
                                          border: '1px solid #ccc',
                                          backgroundColor: 'white',
                                          color: '#666',
                                          cursor: 'pointer',
                                          fontSize: '0.8rem',
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div style={{ 
                                      fontSize: '0.9rem', 
                                      whiteSpace: 'pre-wrap', 
                                      wordWrap: 'break-word',
                                      userSelect: 'text',
                                      cursor: 'text',
                                    }}>
                                      {note.message}
                                    </div>
                                    <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                      <em>
                                        {note.created_by_name}
                                        {note.created_by && (
                                          <>
                                            {' '}
                                            <a href={`mailto:${note.created_by}`} style={{ color: '#007bff', textDecoration: 'none' }}>
                                              {note.created_by}
                                            </a>
                                          </>
                                        )}
                                      </em>
                                    </div>
                                    <div style={{ fontSize: '0.75rem', color: '#999', userSelect: 'none' }}>
                                      {note.created_at ? new Date(note.created_at).toLocaleString() : ''}
                                    </div>
                                    {(updatePermission || deletePermission) && (
                                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '4px' }}>
                                        {updatePermission && note.created_by === localStorage.getItem('userEmail') && (
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              setEditingNoteId(note.job_note_id);
                                              setEditedNoteText(note.message);
                                            }}
                                            style={{ color: '#666' }}
                                          >
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                        {deletePermission && note.created_by === localStorage.getItem('userEmail') && (
                                          <IconButton
                                            size="small"
                                            onClick={() => setNoteToDelete(note.job_note_id)}
                                            style={{ color: '#dc3546d2' }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            ))}
                        </div>
                      ) : (
                        <p style={{ marginTop: '5px', fontSize: '0.9rem' }}>No notes</p>
                      )}
                      {noteToDelete && (
                        <Dialog
                          open={!!noteToDelete}
                          onClose={() => setNoteToDelete(null)}
                          maxWidth="xs"
                          fullWidth
                        >
                          <DialogTitle style={{ color: 'black' }}>Confirm Delete</DialogTitle>
                          <DialogContent>
                            Are you sure you want to delete this note? This action cannot be undone.
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => setNoteToDelete(null)}
                              style={{
                                padding: '6px 12px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                backgroundColor: 'white',
                                cursor: 'pointer',
                                marginRight: '8px'
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleDeleteNote(job.job_id, noteToDelete)}
                              style={{
                                padding: '6px 12px',
                                borderRadius: '4px',
                                border: 'none',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                cursor: 'pointer'
                              }}
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                      {/* optimize A */}

                    {/* Add Note Dialog */}
                    {addNoteDialogOpen && (
                      <Dialog
                        open={addNoteDialogOpen}
                        onClose={() => setAddNoteDialogOpen(false)}
                        maxWidth="sm"
                        fullWidth
                      >
                        <DialogTitle style={{ color: 'black' }}>Add New Note</DialogTitle>
                        <DialogContent>
                          <TextField
                            autoFocus
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 255 }}
                            value={newNoteText}
                            onChange={e => setNewNoteText(e.target.value)}
                            placeholder="Enter note here..."
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setAddNoteDialogOpen(false);
                              setNewNoteText('');
                            }}
                            style={{
                              padding: '6px 12px',
                              borderRadius: '4px',
                              border: '1px solid #ccc',
                              backgroundColor: 'white',
                              cursor: 'pointer',
                              marginRight: '8px'
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={async () => {
                              if (!newNoteText.trim()) {
                                alert('Please enter a note.');
                                return;
                              }
                              try {
                                await handleAddNote(); 
                                await fetchOrder();
                                setAddNoteDialogOpen(false);
                                setNewNoteText('');
                              } catch (error) {
                                toast.error('Failed to add note. Please try again.');
                              }
                            }}
                            style={{
                              padding: '6px 12px',
                              borderRadius: '4px',
                              border: 'none',
                              backgroundColor: '#007bff',
                              color: 'white',
                              cursor: 'pointer'
                            }}
                          >
                            Add
                          </Button>
                        </DialogActions>
                      </Dialog>
                    )}
                  </div>
                </div>
              </div>
              {/* Form Modal */}
              <Dialog
                open={confirmDialogOpen}
                onClose={handleConfirmCancel}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle style={{ color: 'black' }}>Confirm Step Change</DialogTitle>
                <DialogContent style={{ fontSize: '1rem' }}>
                  You are about to move the job <strong>{confirmJobName}</strong> to the step: <strong>{confirmStepName}</strong>. Please confirm to proceed.
                </DialogContent>
                <DialogActions style={{ padding: '16px' }}>
                  <button
                    onClick={handleConfirmCancel}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      marginRight: '8px'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmOk}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '4px',
                      border: 'none',
                      backgroundColor: '#007bff',
                      color: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    Confirm
                  </button>
                </DialogActions>
              </Dialog>
                {formModalVisible && (
                    <Dialog
                      open={formModalVisible}
                      onClose={handleFormCancel}
                      maxWidth="sm"
                      fullWidth
                    >
                      <DialogTitle style={{ color: 'black' }}>
                        Fill required form before proceeding: <strong>{activeStepForms[0]?.stepName || ''}</strong>
                      </DialogTitle>
                      <DialogContent dividers>
                        {activeStepForms.map(form => (
                          <div key={form.form_id} style={{ marginBottom: '20px' }}>
                            {form.form_definition?.fields?.map(field => {
                              const value = formValues[field.name];
                              switch (field.type) {
                                case 'text':
                                  return (
                                    <div key={field.name} style={{ marginBottom: '15px' }}>
                                      <label style={{ fontWeight: '500', marginBottom: '4px', display: 'block' }}>{field.label}</label>
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        rows={1}
                                        value={value}
                                        onChange={e => handleFormChange(field.name, e.target.value)}
                                        InputProps={{ style: { width: '100%' } }}
                                      />
                                    </div>
                                  );
                                case 'boolean':
                                  return (
                                    <div key={field.name} style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                      <label style={{ fontWeight: '500', userSelect: 'none' }}>{field.label}</label>
                                      <Checkbox
                                        checked={value}
                                        onChange={e => handleFormChange(field.name, e.target.checked)}
                                        color="primary"
                                      />
                                    </div>
                                  );
                                case 'dropdown':
                                  return (
                                    <div key={field.name} style={{ marginBottom: '15px' }}>
                                      <label style={{ fontWeight: '500', marginBottom: '4px', display: 'block' }}>{field.label}</label>
                                      <TextField
                                        select
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        value={value}
                                        onChange={e => handleFormChange(field.name, e.target.value)}
                                        SelectProps={{ native: true }}
                                      >
                                        <option value="">Select...</option>
                                        {field.options?.map(option => (
                                          <option key={option} value={option}>{option}</option>
                                        ))}
                                      </TextField>
                                    </div>
                                  );
                                case 'datetime':
                                  return (
                                    <div key={field.name} style={{ marginBottom: '15px' }}>
                                      <label style={{ fontWeight: '500', marginBottom: '4px', display: 'block' }}>{field.label}</label>
                                      <TextField
                                        type="datetime-local"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        value={value}
                                        onChange={e => handleFormChange(field.name, e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                      />
                                    </div>
                                  );
                                default:
                                  return null;
                              }
                            })}
                          </div>
                        ))}
                      </DialogContent>
                      <DialogActions style={{ padding: '16px' }}>
                        <button
                          onClick={handleFormCancel}
                          style={{
                            padding: '6px 12px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            marginRight: '8px'
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleFormSubmit}
                          style={{
                            padding: '6px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            backgroundColor: '#007bff',
                            color: 'white',
                            cursor: 'pointer'
                          }}
                        >
                          Submit
                        </button>
                      </DialogActions>
                    </Dialog>
                  )}
                </>   
                );
                  })
                  
                )
                : (
                  <p>No jobs available.</p>
                )}
              </div>
            </div>

            {/*optimize V */}
            
            <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)', position: 'relative' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <h3 style={{ marginTop: 0, marginBottom: 0 }}>Timeline</h3>
                <button
                  onClick={openCreateScheduleDialog}
                  style={{
                    padding: '6px 12px',
                    borderRadius: '4px',
                    border: '1px solid #007bff',
                    backgroundColor: 'transparent',
                    color: '#007bff',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    height: '32px',
                  }}
                >
                  Create Schedule
                </button>
              </div>
              <h5 style={{ color: '#666', marginTop: '-10px', marginBottom: '10px' }}>Track order progress</h5>
              
              {/* Shared filters section */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: 2, backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '6px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Log Types</Typography>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                    <FilterListIcon />
                    <FormGroup row>
                      {['order', 'job', 'form', 'schedule'].map(type => (
                        <FormControlLabel
                          key={type}
                          control={
                            <Checkbox
                              checked={logTypeFilter[type]}
                              onChange={handleLogTypeChange}
                              name={type}
                              color="primary"
                            />
                          }
                          label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {type === 'order' && <WorkIcon sx={{ fontSize: 18 }} />}
                              {type === 'job' && <AssignmentIcon sx={{ fontSize: 18 }} />}
                              {type === 'form' && <DescriptionIcon sx={{ fontSize: 18 }} />}
                              <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                            </Box>
                          }
                        />
                      ))}
                    </FormGroup>
                  </Box>
                </Box>

                {order.jobs && order.jobs.length > 0 && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxWidth: '60%', justifyContent: 'flex-end' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Filter by Job</Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {order.jobs.map(job => (
                        <Chip
                          key={job.job_id}
                          label={job.job_name}
                          variant={jobFilter.includes(job.job_id) ? 'filled' : 'outlined'}
                          color={jobFilter.includes(job.job_id) ? 'primary' : 'default'}
                          onClick={() => toggleJobFilter(job.job_id)}
                          clickable
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
              
              {/* Two-column layout for logs */}
              <div style={{ display: 'flex', gap: '20px' }}>
                {/* Left column: Activity logs */}
                <div style={{ flexBasis: '50%', flexGrow: 0, display: 'flex', flexDirection: 'column' }}>
                  <div style={{ 
                    backgroundColor: '#fafafa', 
                    borderRadius: '8px', 
                    padding: '20px', 
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)', 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #e0e0e0'
                  }}>
                    <Typography variant="subtitle1" sx={{ 
                      fontWeight: 600, 
                      marginBottom: 3,
                      color: '#333333',
                      fontSize: '1rem',
                      borderBottom: '1px solid #e0e0e0',
                      paddingBottom: '8px'
                    }}>
                      Activity Logs
                    </Typography>
                    <List sx={{ 
                      flex: 1,
                      maxHeight: 450, 
                      overflowY: 'auto', 
                      backgroundColor: 'white',
                      borderRadius: '4px',
                      padding: '8px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#bdbdbd',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: '#9e9e9e',
                      }
                    }}>
                      {combinedLogs.filter(log => log.type !== 'schedule').length === 0 && (
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          height: '200px',
                          color: '#757575'
                        }}>
                          <EventNoteIcon sx={{ fontSize: 48, color: '#e0e0e0', mb: 2 }} />
                          <Typography variant="body2" color="textSecondary">
                            No activity logs to display.
                          </Typography>
                          <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                            Activity logs will appear here as changes are made.
                          </Typography>
                        </Box>
                      )}
                      {combinedLogs
                        .filter(log => log.type !== 'schedule')
                        .map((log, index) => (
                          <ListItem 
                            key={log.id || log.job_log_id || log.form_log_id} 
                            alignItems="flex-start" 
                            divider
                            sx={{ 
                              flexDirection: 'column', 
                              alignItems: 'stretch',
                              padding: '12px',
                              marginBottom: '8px',
                              backgroundColor: '#ffffff',
                              borderRadius: '4px',
                              border: '1px solid #f0f0f0',
                              '&:hover': {
                                borderColor: '#d0d0d0',
                                backgroundColor: '#fafafa'
                              }
                            }}
                          >
                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', width: '100%' }}>
                              <ListItemAvatar>
                                <Avatar sx={{ 
                                  bgcolor: '#616161', 
                                  color: 'white',
                                  width: 36,
                                  height: 36,
                                  fontSize: '0.9rem'
                                }}>
                                  {getIconByType(log.type)}
                                </Avatar>
                              </ListItemAvatar>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" component="div" sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  lineHeight: 1.4,
                                  mb: 1,
                                  color: '#212121'
                                }}>
                                  {log.type === 'job' && (
                                    <>
                                      <Box component="span" sx={{ fontWeight: 600 }}>{log.job_name}</Box>: 
                                      <Box component="span" sx={{ color: '#424242' }}>{log.log[0]?.old}</Box> 
                                      <ArrowRightAltIcon fontSize="small" sx={{ verticalAlign: 'middle', mx: 0.5, color: '#9e9e9e' }} /> 
                                      <Box component="span" sx={{ color: '#424242', fontWeight: 500 }}>{log.log[0]?.new}</Box>
                                    </>
                                  )}
                                  {log.type === 'form' && (
                                    <>
                                      <Box component="span" sx={{ fontWeight: 600 }}>{log.form_step_name}</Box>: 
                                      <Box component="span" sx={{ color: '#424242' }}>Form Created</Box>
                                      {log.log && Object.keys(log.log).length > 0 && (
                                        <span
                                          onClick={() => toggleFormExpand(log.form_log_id)}
                                          style={{
                                            marginLeft: 12,
                                            cursor: 'pointer',
                                            color: '#424242',
                                            fontSize: '0.8rem',
                                            userSelect: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            fontWeight: 500,
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            border: '1px solid #e0e0e0'
                                          }}
                                          role="button"
                                          tabIndex={0}
                                          onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') toggleFormExpand(log.form_log_id); }}
                                          aria-expanded={!!expandedFormLogs[log.form_log_id]}
                                          aria-label={expandedFormLogs[log.form_log_id] ? 'Hide Details' : 'Show Details'}
                                        >
                                          {expandedFormLogs[log.form_log_id] ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                          {expandedFormLogs[log.form_log_id] ? 'Hide Details' : 'Show Details'}
                                        </span>
                                      )}
                                    </>
                                  )}
                                  {log.type === 'order' && (
                                    <>
                                      <Box component="span" sx={{ fontWeight: 600 }}>Order</Box>: 
                                      <Box component="span" sx={{ color: '#424242' }}>{log.log[0]?.field}</Box>: 
                                      <Box component="span" sx={{ color: '#424242' }}>{log.log[0]?.old}</Box> 
                                      <ArrowRightAltIcon fontSize="small" sx={{ verticalAlign: 'middle', mx: 0.5, color: '#9e9e9e' }} /> 
                                      <Box component="span" sx={{ color: '#424242', fontWeight: 500 }}>{log.log[0]?.new}</Box>
                                    </>
                                  )}
                                </Typography>
                                
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
                                  <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.85rem', color: '#616161' }}>
                                    {log.created_by_name && (
                                      <>
                                        <Box component="span" sx={{ fontWeight: 500, color: '#424242' }}>
                                          {log.created_by_name}
                                        </Box>
                                        {' • '}
                                        <Link 
                                          href={`mailto:${log.created_by}`}
                                          sx={{ 
                                            display: 'inline-flex', 
                                            alignItems: 'center', 
                                            gap: 0.5,
                                            color: '#424242',
                                            textDecoration: 'none',
                                            '&:hover': { color: '#1976d2' }
                                          }}
                                        >
                                          {log.created_by}
                                        </Link>
                                      </>
                                    )}
                                    {!log.created_by_name && log.created_by}
                                  </Typography>
                                  
                                  <Typography variant="caption" color="textSecondary" sx={{ 
                                    fontSize: '0.8rem',
                                    fontWeight: 500,
                                    color: '#757575',
                                    backgroundColor: '#f5f5f5',
                                    padding: '2px 8px',
                                    borderRadius: '12px'
                                  }}>
                                    {formatDateTime(log.created_at)}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                            
                            {log.type === 'form' && expandedFormLogs[log.form_log_id] && (
                              <Box sx={{ 
                                mt: 2, 
                                ml: 9, 
                                overflowX: 'auto',
                                backgroundColor: '#fafafa',
                                borderRadius: '4px',
                                border: '1px solid #e0e0e0',
                                padding: '12px'
                              }}>
                                <Typography variant="subtitle2" sx={{ 
                                  fontWeight: 600, 
                                  mb: 1, 
                                  color: '#424242',
                                  fontSize: '0.9rem'
                                }}>
                                  Form Details
                                </Typography>
                                <table style={{ 
                                  borderCollapse: 'collapse', 
                                  width: '100%', 
                                  fontSize: '0.85rem',
                                  tableLayout: 'fixed'
                                }}>
                                  <thead>
                                    <tr>
                                      <th style={{ 
                                        border: '1px solid #ddd', 
                                        padding: '8px 10px', 
                                        backgroundColor: '#f5f5f5',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#424242'
                                      }}>Field</th>
                                      <th style={{ 
                                        border: '1px solid #ddd', 
                                        padding: '8px 10px', 
                                        backgroundColor: '#f5f5f5',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#424242'
                                      }}>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Object.entries(log.log).map(([field, value]) => (
                                      <tr key={field}>
                                        <td style={{ 
                                          border: '1px solid #ddd', 
                                          padding: '8px 10px', 
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          backgroundColor: '#fafafa',
                                          fontWeight: 500,
                                          color: '#424242'
                                        }}>{field}</td>
                                        <td style={{ 
                                          border: '1px solid #ddd', 
                                          padding: '8px 10px', 
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          backgroundColor: '#ffffff',
                                          color: '#424242'
                                        }}>
                                          {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </Box>
                            )}
                          </ListItem>
                        ))}
                    </List>
                  </div>
                </div>

                {/* Right column: Schedule logs */}
                <div style={{ flexBasis: '50%', flexGrow: 0, display: 'flex', flexDirection: 'column' }}>
                  <div style={{ 
                    backgroundColor: '#fafafa', 
                    borderRadius: '8px', 
                    padding: '20px', 
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)', 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #e0e0e0'
                  }}>
                    <Typography variant="subtitle1" sx={{ 
                      fontWeight: 600, 
                      marginBottom: 3,
                      color: '#333333',
                      fontSize: '1rem',
                      borderBottom: '1px solid #e0e0e0',
                      paddingBottom: '8px'
                    }}>
                      Schedules
                    </Typography>
                    <List sx={{ 
                      flex: 1,
                      maxHeight: 450, 
                      overflowY: 'auto', 
                      backgroundColor: 'white',
                      borderRadius: '4px',
                      padding: '8px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#bdbdbd',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: '#9e9e9e',
                      }
                    }}>
                      {combinedLogs.filter(log => log.type === 'schedule').length === 0 && (
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          height: '200px',
                          color: '#757575'
                        }}>
                          <EventNoteIcon sx={{ fontSize: 48, color: '#e0e0e0', mb: 2 }} />
                          <Typography variant="body2" color="textSecondary">
                            No schedules to display.
                          </Typography>
                          <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                            Schedules will appear here when created.
                          </Typography>
                        </Box>
                      )}
                      {combinedLogs
                        .filter(log => log.type === 'schedule')
                        .map(log => {
                          const isEnabled = log.enabled === 1;
                          const step = order.job_flow_steps.find(s => s.id === log.job_flow_step_id);
                          const stepName = step ? step.stepName : 'Unknown Step';
                          
                          return (
                            <ListItem 
                              key={log.id} 
                              alignItems="flex-start" 
                              divider
                              sx={{ 
                                flexDirection: 'column', 
                                alignItems: 'stretch',
                                padding: '12px',
                                marginBottom: '8px',
                                backgroundColor: isEnabled ? '#ffffff' : '#fafafa',
                                borderRadius: '4px',
                                border: '1px solid #f0f0f0',
                                opacity: isEnabled ? 1 : 0.7,
                                '&:hover': {
                                  borderColor: '#d0d0d0',
                                  backgroundColor: isEnabled ? '#fafafa' : '#f5f5f5'
                                }
                              }}
                            >
                              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', width: '100%' }}>
                                <ListItemAvatar>
                                  <Avatar sx={{ 
                                    bgcolor: isEnabled ? '#616161' : '#bdbdbd', 
                                    color: 'white',
                                    width: 36,
                                    height: 36,
                                    fontSize: '0.9rem'
                                  }}>
                                    {getIconByType(log.type)}
                                  </Avatar>
                                </ListItemAvatar>
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="h6" component="div" sx={{
                                    fontWeight: 600,
                                    fontSize: '1.1rem',
                                    lineHeight: 1.3,
                                    mb: 1,
                                    color: isEnabled ? '#212121' : '#757575'
                                  }}>
                                    {log.title || 'Untitled Schedule'}
                                  </Typography>
                                  
                                  {/* Second row: Job name and step name */}
                                  <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 1, 
                                    mb: 1.5,
                                    flexWrap: 'wrap'
                                  }}>
                                    <Box sx={{ 
                                      fontWeight: 500, 
                                      fontSize: '0.9rem',
                                      color: isEnabled ? '#424242' : '#9e9e9e',
                                      backgroundColor: isEnabled ? '#f5f5f5' : '#eeeeee',
                                      padding: '2px 8px',
                                      borderRadius: '4px'
                                    }}>
                                      {log.job_name}: {stepName}
                                    </Box>
                                    <Box sx={{ 
                                      color: isEnabled ? '#616161' : '#bdbdbd', 
                                      fontSize: '0.85rem', 
                                      whiteSpace: 'nowrap',
                                      fontWeight: 500,
                                      marginLeft: 'auto'
                                    }}>
                                      {new Date(log.start_datetime).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })} - {new Date(log.end_datetime).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}
                                    </Box>
                                    {deletePermission && isEnabled && (
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => handleDisableSchedule(log.id)}
                                        sx={{
                                          marginLeft: 1,
                                          fontSize: '0.75rem',
                                          padding: '2px 8px',
                                          minWidth: 'auto',
                                          borderColor: '#d32f2f',
                                          color: '#d32f2f',
                                          '&:hover': {
                                            borderColor: '#b71c1c',
                                            backgroundColor: 'rgba(211, 47, 47, 0.04)'
                                          }
                                        }}
                                      >
                                        Disable
                                      </Button>
                                    )}
                                  </Box>
                                  
                                  {/* Always show schedule details */}
                                  <Box sx={{ 
                                    mt: 2, 
                                    ml: 0, 
                                    p: 2, 
                                    borderRadius: '4px', 
                                    fontSize: '0.85rem', 
                                    backgroundColor: '#fafafa',
                                    border: '1px solid #e0e0e0',
                                    overflowX: 'auto'
                                  }}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 16px', alignItems: 'baseline' }}>
                                      <Box sx={{ fontWeight: 600, color: '#424242' }}>Note:</Box>
                                      <Box sx={{ color: '#424242' }}>{log.note || 'N/A'}</Box>
                                      
                                      <Box sx={{ fontWeight: 600, color: '#424242' }}>Location:</Box>
                                      <Box sx={{ color: '#424242' }}>{log.location || 'N/A'}</Box>
                                      
                                      <Box sx={{ fontWeight: 600, color: '#424242' }}>Attendees:</Box>
                                      <Box sx={{ color: '#424242' }}>{Array.isArray(log.attendees) ? log.attendees.join(', ') : log.attendees || 'N/A'}</Box>
                                    </Box>
                                  </Box>
                                  
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.85rem', color: '#616161' }}>
                                      {log.created_by_name && (
                                        <>
                                          <Box component="span" sx={{ fontWeight: 500, color: '#424242' }}>
                                            {log.created_by_name}
                                          </Box>
                                          {' • '}
                                          <Link 
                                            href={`mailto:${log.created_by}`}
                                            sx={{ 
                                              display: 'inline-flex', 
                                              alignItems: 'center', 
                                              gap: 0.5,
                                              color: '#424242',
                                              textDecoration: 'none',
                                              '&:hover': { color: '#1976d2' }
                                            }}
                                          >
                                            {log.created_by}
                                          </Link>
                                        </>
                                      )}
                                      {!log.created_by_name && log.created_by}
                                    </Typography>
                                    
                                    <Typography variant="caption" color="textSecondary" sx={{ 
                                      fontSize: '0.8rem',
                                      fontWeight: 500,
                                      color: '#757575',
                                      backgroundColor: '#f5f5f5',
                                      padding: '2px 8px',
                                      borderRadius: '12px'
                                    }}>
                                      {formatDateTime(log.created_at)}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </ListItem>
                          );
                        })}
                    </List>
                  </div>
                </div>
              </div>
            </div>

            {/* optimize A */}
          </div>

          {/* Right column: 30% width */}
            <div style={{ flexBasis: '30%', flexGrow: 0, display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {/* Order Description box */}
              <div style={{ position: 'relative', backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                <h3>Details</h3>
                <h5 style={{ color: '#666', marginTop: '-10px', marginBottom: '10px' }}>Summary of the order</h5>
                {(updatePermission && isAccessible) && (
                  <button
                    onClick={handleDetailsEditToggle}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 0,
                      lineHeight: 1,
                      fontSize: '1.2rem',
                      color: isEditingDetails ? 'green' : undefined,
                    }}
                    aria-label={isEditingDetails ? 'Update Order Details' : 'Edit Order Details'}
                  >
                    {isEditingDetails ? <FileUploadOutlinedIcon /> : <EditOutlinedIcon />}
                  </button>
                )}
                <textarea
                  readOnly={!isEditingDetails}
                  value={editedOrderDetails.order_description}
                  onChange={e => handleDetailsChange('order_description', e.target.value)}
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '10px',
                    minHeight: '100px',
                    resize: 'vertical',
                    width: '100%',
                    fontFamily: 'inherit',
                    fontSize: '1rem',
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word',
                    marginBottom: '15px',
                    backgroundColor: '#fff',
                    cursor: isEditingDetails ? 'text' : 'default',
                  }}
                  maxLength={1024}
                />
                {[
                  { label: 'Quote', field: 'quote' },
                  { label: 'Invoice Number', field: 'invoice_number' },
                  { label: 'Purchase Order Number', field: 'purchase_order_number' },
                  { label: 'Folder Path', field: 'folder_path' },
                ].map(({ label, field }) => (
                  <input
                    key={field}
                    type="text"
                    value={editedOrderDetails[field]}
                    onChange={e => handleDetailsChange(field, e.target.value)}
                    readOnly={!isEditingDetails}
                    maxLength={255}
                    placeholder={label}
                    style={{
                      width: '100%',
                      minWidth: '100%',
                      padding: '8px 10px',
                      marginBottom: '12px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      fontSize: '1rem',
                      backgroundColor: isEditingDetails ? '#fff' : '#f9f9f9',
                      cursor: isEditingDetails ? 'text' : 'default',
                    }}
                    aria-label={label}
                  />
                ))}
              </div>



              {/* Customer box container */}
              <div style={{ position: 'relative', backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                <h3>Customer</h3>
                <h5 style={{ color: '#666', marginTop: '-10px', marginBottom: '10px' }}>Information detail</h5>
                  {(updatePermission && isAccessible) && (
                  <button
                    onClick={openCustomersDialog}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 0,
                      lineHeight: 1,
                      fontSize: '1.2rem'
                    }}
                    aria-label="Edit Customer description"
                  >
                    <EditOutlinedIcon />
                  </button>
                )}
                {/* Grey box container */}
                <div style={{ backgroundColor: '#f6f6f6', padding: '15px', borderRadius: '6px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {/* Customer Details box */}
                  <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)', cursor: updatePermission && isAccessible ? 'pointer' : 'default' }}>
                    <h3>Contact Details</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '0.95rem' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '6px 10px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          userSelect: 'all',
                          minHeight: '32px',
                          cursor: 'default',
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                          <PersonIcon style={{ fontSize: '18px' }} />
                          Name
                        </span>
                        <span style={{ color: 'black', overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                          {order.customer?.customer_name || 'N/A'}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '6px 10px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          userSelect: 'all',
                          minHeight: '32px',
                          cursor: order.customer?.customer_email ? 'pointer' : 'default',
                          color: order.customer?.customer_email ? '#007bff' : '#888',
                        }}
                        onClick={() => {
                          if (order.customer?.customer_email) {
                            window.open(`mailto:${order.customer.customer_email}`, '_blank');
                          }
                        }}
                        title={order.customer?.customer_email ? `Send email to ${order.customer.customer_email}` : ''}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                          <EmailIcon style={{ fontSize: '18px' }} />
                          Email
                        </span>
                        <span style={{ overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                          {order.customer?.customer_email || 'N/A'}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '6px 10px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          userSelect: 'all',
                          minHeight: '32px',
                          cursor: order.customer?.customer_number ? 'pointer' : 'default',
                          color: order.customer?.customer_number ? '#007bff' : '#888',
                        }}
                        onClick={() => {
                          if (order.customer?.customer_number) {
                            window.open(`tel:${order.customer.customer_number}`, '_blank');
                          }
                        }}
                        title={order.customer?.customer_number ? `Call ${order.customer.customer_number}` : ''}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                          <PhoneIcon style={{ fontSize: '18px' }} />
                          Phone
                        </span>
                        <span style={{ overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                          {order.customer?.customer_number || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Company Details box */}
                  {order.company && (
                    <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)', cursor: updatePermission && isAccessible ? 'pointer' : 'default' }}>
                      <h3>Company Details</h3>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '0.95rem' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '6px 10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            userSelect: 'all',
                            minHeight: '32px',
                            cursor: 'default',
                          }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                            <PersonIcon style={{ fontSize: '18px' }} />
                            Name
                          </span>
                          <span style={{ color: 'black', overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                            {order.company.company_name || 'N/A'}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '6px 10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            userSelect: 'all',
                            minHeight: '32px',
                            cursor: order.company.company_email ? 'pointer' : 'default',
                            color: order.company.company_email ? '#007bff' : '#888',
                          }}
                          onClick={() => {
                            if (order.company.company_email) {
                              window.open(`mailto:${order.company.company_email}`, '_blank');
                            }
                          }}
                          title={order.company.company_email ? `Send email to ${order.company.company_email}` : ''}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                            <EmailIcon style={{ fontSize: '18px' }} />
                            Email
                          </span>
                          <span style={{ overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                            {order.company.company_email || 'N/A'}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '6px 10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            userSelect: 'all',
                            minHeight: '32px',
                            cursor: order.company.company_number ? 'pointer' : 'default',
                            color: order.company.company_number ? '#007bff' : '#888',
                          }}
                          onClick={() => {
                            if (order.company.company_number) {
                              window.open(`tel:${order.company.company_number}`, '_blank');
                            }
                          }}
                          title={order.company.company_number ? `Call ${order.company.company_number}` : ''}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                            <PhoneIcon style={{ fontSize: '18px' }} />
                            Phone
                          </span>
                          <span style={{ overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                            {order.company.company_number || 'N/A'}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '6px 10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            userSelect: 'all',
                            minHeight: '32px',
                            cursor: order.company.company_website ? 'pointer' : 'default',
                            color: order.company.company_website ? '#007bff' : '#888',
                          }}
                          onClick={() => {
                            if (order.company.company_website) {
                              let url = order.company.company_website;
                              window.open(url, '_blank');
                            }
                          }}
                          title={order.company.company_website ? `Open website ${order.company.company_website}` : ''}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', color: '#666', fontWeight: '500', minWidth: '100px', fontSize: '0.85rem', userSelect: 'none', gap: '6px' }}>
                            <LanguageIcon style={{ fontSize: '18px' }} />
                            Website
                          </span>
                          <span style={{ overflowWrap: 'break-word', flexGrow: 1, textAlign: 'right' }}>
                            {order.company.company_website || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Address box */}
                  <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 0 5px rgba(0,0,0,0.1)', cursor: updatePermission ? 'pointer' : 'default' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <h3 style={{ margin: 0 }}>Address</h3>
                      {isAccessible && updatePermission && (
                        <IconButton
                          onClick={handleOpenEditAddress}
                          size="small"
                          aria-label="Edit Address"
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                    <div
                      style={{ fontSize: '0.95rem', lineHeight: 1.4, whiteSpace: 'pre-wrap', userSelect: 'all', cursor: 'default', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                      onClick={() => {
                        const fullAddress = `${order.street_address || ''}${order.street_address ? ', ' : ''}${order.suburb || ''}${order.suburb ? ', ' : ''}${order.state || ''}${order.state ? ', ' : ''}${order.postal_code || ''}`;
                        if (fullAddress.trim()) {
                          navigator.clipboard.writeText(fullAddress)
                            .then(() => toast.success('Address copied to clipboard!'))
                            .catch(() => toast.error('Failed to copy address.'));
                        }
                      }}
                      title="Click to copy address"
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <HomeIcon style={{ fontSize: '18px', color: '#666' }} />
                        {order.street_address || ''}{order.street_address ? ', ' : ''}
                        {order.suburb || ''}{order.suburb ? ', ' : ''}
                        {order.state || ''}{order.state ? ', ' : ''}
                        {order.postal_code || ''}
                      </span>
                      <ContentCopyIcon style={{ color: '#888', fontSize: '18px', marginLeft: '8px' }} />
                    </div>
                    <button
                      onClick={() => {
                        const address = encodeURIComponent(
                          `${order.street_address || ''} ${order.suburb || ''} ${order.state || ''} ${order.postal_code || ''}`
                        );
                        const url = `https://www.google.com/maps/search/?api=1&query=${address}`;
                        window.open(url, '_blank');
                      }}
                      style={{
                        marginTop: '10px',
                        border: '1px solid #007bff',
                        backgroundColor: 'transparent',
                        color: '#007bff',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        alignSelf: 'flex-start'
                      }}
                    >
                      Open in Google Maps
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </div>
          <Dialog open={createScheduleDialogOpen} onClose={handleCreateScheduleCancel} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: 'black', backgroundColor: '#f0f0f0' }}>Create New Schedule</DialogTitle>
              <DialogContent dividers>
                <TextField
                  select
                  label="Job"
                  value={selectedJobId}
                  onChange={e => setSelectedJobId(e.target.value)}
                  fullWidth
                  margin="normal"
                  SelectProps={{ native: true }}
                  required
                >
                  <option value="">Select Job</option>
                  {order.jobs.map(job => (
                    <option key={job.job_id} value={job.job_id}>{job.job_name}</option>
                  ))}
                </TextField>

                <TextField
                  select
                  label="Job Flow Step"
                  value={selectedStepId}
                  onChange={e => setSelectedStepId(e.target.value)}
                  fullWidth
                  margin="normal"
                  SelectProps={{ native: true }}
                  required
                >
                  <option value="">Select Step</option>
                  {order.job_flow_steps.map(step => (
                    <option key={step.id} value={step.id}>{step.stepName}</option>
                  ))}
                </TextField>

                {/* optimize V */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, color: 'rgba(0, 0, 0, 0.6)' }}>
                    Job Flow Color
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      border: '1px solid rgba(0, 0, 0, 0.23)',
                      borderRadius: '4px',
                      padding: '16.5px 14px',
                      '&:hover': {
                        borderColor: 'rgba(0, 0, 0, 0.87)',
                      },
                      '&:focus-within': {
                        borderColor: '#1976d2',
                        borderWidth: '2px',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '4px',
                        backgroundColor: scheduleColor || '#3174ad',
                        border: '1px solid rgba(0, 0, 0, 0.23)',
                        cursor: 'pointer',
                        flexShrink: 0,
                      }}
                      onClick={() => {
                        // 触发隐藏的color input
                        document.getElementById('schedule-color-input')?.click();
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        flexGrow: 1,
                        color: scheduleColor ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        document.getElementById('schedule-color-input')?.click();
                      }}
                    >
                      {scheduleColor || 'Select color'}
                    </Typography>
                    <input
                      id="schedule-color-input"
                      type="color"
                      value={scheduleColor || '#3174ad'}
                      onChange={e => setScheduleColor(e.target.value)}
                      style={{
                        position: 'absolute',
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                  </Box>
                </Box>
                {/* optimize A */}

                <TextField
                  label="Title"
                  value={scheduleTitle}
                  onChange={e => setScheduleTitle(e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                  multiline
                  rows={1}
                />

                <TextField
                  label="Location"
                  value={scheduleLocation}
                  onChange={e => setScheduleLocation(e.target.value)}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={1}
                />

                <TextField
                  label="Note"
                  value={scheduleNote}
                  onChange={e => setScheduleNote(e.target.value)}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={3}
                />

                <TextField
                  label="Attendees (comma separated)"
                  value={scheduleAttendees}
                  onChange={e => setScheduleAttendees(e.target.value)}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={1}
                />

                <TextField
                  label="Start Date & Time"
                  type="datetime-local"
                  value={scheduleStart}
                  onChange={e => setScheduleStart(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  required
                />

                <TextField
                  label="End Date & Time"
                  type="datetime-local"
                  value={scheduleEnd}
                  onChange={e => setScheduleEnd(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </DialogContent>
            <DialogActions>
              <Button onClick={handleCreateScheduleCancel}>Cancel</Button>
              <Button onClick={handleCreateScheduleSubmit} variant="contained">Create</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={addJobDialogOpen}
            onClose={handleAddJobCancel}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle style={{ color: 'black' }}>Add New Job</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                label="Job Name"
                variant="outlined"
                fullWidth
                multiline
                rows={1}
                margin="normal"
                value={newJobName}
                onChange={e => setNewJobName(e.target.value)}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Job Description"
                variant="outlined"
                fullWidth
                margin="normal"
                multiline
                rows={3}
                value={newJobDescription}
                onChange={e => setNewJobDescription(e.target.value)}
              />
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={newJobUrgent} onChange={e => setNewJobUrgent(e.target.checked)} />}
                  label="Urgent"
                />
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAddJobCancel} style={{ padding: '6px 12px' }}>
                Cancel
              </Button>
              <Button onClick={handleAddJobSubmit} variant="contained" color="primary" style={{ padding: '6px 12px' }}>
                Add
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={deleteJobDialogOpen}
            onClose={handleDeleteJobCancel}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle style={{ color: 'black' }}>Delete Job</DialogTitle>
            <DialogContent>
              <TextField
                select
                label="Select Job"
                value={selectedDeleteJobId}
                onChange={e => setSelectedDeleteJobId(e.target.value)}
                fullWidth
                margin="normal"
                SelectProps={{ native: true }}
                required
              >
                {order.jobs.map(job => (
                  <option key={job.job_id} value={job.job_id}>{job.job_name}</option>
                ))}
              </TextField>
              <TextField
                label="Type the job name to confirm"
                variant="outlined"
                fullWidth
                multiline
                rows={1}
                margin="normal"
                value={deleteJobConfirmName}
                onChange={e => setDeleteJobConfirmName(e.target.value)}
                disabled={!selectedDeleteJobId}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteJobCancel} style={{ padding: '6px 12px' }}>
                Cancel
              </Button>
              <Button
                onClick={handleDeleteJobConfirm}
                variant="contained"
                color="error"
                style={{ padding: '6px 12px' }}
                disabled={
                  !selectedDeleteJobId ||
                  !deleteJobConfirmName ||
                  (order.jobs.find(job => job.job_id === selectedDeleteJobId)?.job_name !== deleteJobConfirmName)
                }
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
          {editTagsDialogOpen && editingJob && (
            <Dialog
              open={editTagsDialogOpen}
              onClose={() => setEditTagsDialogOpen(false)}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle style={{ color: 'black' }}>Edit Job Status for {editingJob.job_name}</DialogTitle>
              <DialogContent>
                {['urgent', 'completed', 'do_not_proceed'].map(tag => (
                  <FormControlLabel
                    key={tag}
                    control={
                      <Checkbox
                        checked={editTagsState[tag]}
                        onChange={() => {
                          const isSelected = editTagsState[tag];
                          let newState = { urgent: false, completed: false, do_not_proceed: false };
                          if (!isSelected) {
                            newState[tag] = true;
                          }
                          setEditTagsState(newState);
                        }}
                        color="primary"
                      />
                    }
                    label={tag.charAt(0).toUpperCase() + tag.slice(1).replace(/_/g, ' ')}
                  />
                ))}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setEditTagsDialogOpen(false)}>Cancel</Button>
                <Button onClick={handleEditTagsSave} variant="contained" color="primary">Save</Button>
              </DialogActions>
            </Dialog>
          )}
          <Dialog
            open={allProductsDialogOpen}
            onClose={closeAllProductsDialog}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle style={{ color: 'black' }}>Edit Products for Job</DialogTitle>
            <DialogContent dividers style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              <TextField
                label="Search products"
                variant="outlined"
                fullWidth
                multiline
                rows={1}
                margin="normal"
                value={productSearchTerm}
                onChange={e => setProductSearchTerm(e.target.value)}
                placeholder="Search by product name, category, or department"
              />

              {loadingProducts ? (
                <div>Loading products...</div>
              ) : filteredProducts.length === 0 ? (
                <div>No products found.</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Department</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Category</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Product Name</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Price</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Stock</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Unit</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProducts.map(product => {
                      const existingProduct = editingJobProducts.find(p => p.product_item_id === product.product_item_id);
                      const quantity = existingProduct ? existingProduct.quantity : 0;
                      return (
                        <tr key={product.product_item_id}>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.departmentName}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.categoryName}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.item_name}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{Number(product.item_price).toFixed(2)}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{product.item_stock}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.item_unit_symbol || product.item_unit || 'N/A'}</td>
                          <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>
                            <TextField
                            type="number"
                            inputProps={{ min: 0 }}
                            value={quantity}
                            onChange={e => handleProductQuantityChange(product.product_item_id, e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ width: '80px' }}
                          />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAllProductsDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={saveJobProducts} color="primary" variant="contained">
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={customersDialogOpen} onClose={closeCustomersDialog} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: 'black' }}>
              <span>Customer</span>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button variant="outlined" size="small" onClick={() => openCreateCustomerDialog('Individual')}>
                  Create Individual Customer
                </Button>
                <Button variant="outlined" size="small" onClick={() => openCreateCustomerDialog('Company')}>
                  Create Company Customer
                </Button>
              </Box>
            </DialogTitle>
            <DialogContent dividers>
              {loadingCustomers ? (
                <div>Loading customers...</div>
              ) : (
                <Box sx={{ display: 'flex', gap: 4 }}>
                  {/* Left column: Individual Customers */}
                  <Box 
                    sx={{ 
                      flex: 1, 
                      maxHeight: '50vh',
                      overflowY: 'auto', 
                      borderRight: '1px solid #ccc', 
                      pr: 2, 
                      backgroundColor: '#fafafa', 
                      borderRadius: 1,
                      p: 2,
                      boxShadow: 'inset 0 0 5px rgba(0,0,0,0.05)',
                    }}
                  >
                    <Typography variant="h6" sx={{ mb: 1, borderBottom: '2px solid #1976d2', pb: 0.5 }}>Individual Customers</Typography>
                    <TextField
                      placeholder="Search individual customers"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={individualSearchTerm}
                      onChange={e => setIndividualSearchTerm(e.target.value)}
                      sx={{ mb: 2 }}
                    />
                    <List sx={{ bgcolor: 'white', borderRadius: 1, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                      {filteredIndividuals.length === 0 ? (
                        <Typography variant="body2" color="textSecondary" align="center" sx={{ p: 2 }}>No individual customers found.</Typography>
                      ) : (
                        filteredIndividuals.map(cust => (
                          <ListItem 
                            key={cust.customer_id} 
                            button 
                            selected={selectedCustomer?.type === 'individual' && selectedCustomer.customerId === cust.customer_id}
                            onClick={() => handleSelectCustomer('individual', cust.customer_id)}
                            sx={{
                              borderBottom: '1px solid #eee',
                              '&:last-child': { borderBottom: 'none' },
                              px: 2,
                              py: 1.5,
                              justifyContent: 'space-between',
                            }}
                          >
                            <ListItemText primary={cust.customer_name} secondary={cust.customer_email} />
                            <EditIcon 
                              sx={{ cursor: 'pointer' }} 
                              onClick={e => { e.stopPropagation(); openEditCustomerDialog('individual', cust); }} 
                              aria-label={`Edit individual customer ${cust.customer_name}`}
                            />
                          </ListItem>
                        ))
                      )}
                    </List>
                  </Box>

                {/* Right column: Companies */}
                <Box 
                  sx={{ 
                    flex: 1, 
                    maxHeight: '50vh',
                    overflowY: 'auto', 
                    pl: 2, 
                    backgroundColor: '#fafafa', 
                    borderRadius: 1,
                    p: 2,
                    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.05)',
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 1, borderBottom: '2px solid #1976d2', pb: 0.5 }}>Company Customers</Typography>
                  <TextField
                    placeholder="Search companies"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={companySearchTerm}
                    onChange={e => setCompanySearchTerm(e.target.value)}
                    sx={{ mb: 2 }}
                  />
                  <List sx={{ bgcolor: 'white', borderRadius: 1, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                    {filteredCompanies.length === 0 ? (
                      <Typography variant="body2" color="textSecondary" align="center" sx={{ p: 2 }}>No companies found.</Typography>
                    ) : (
                      filteredCompanies.map(company => (
                        <div key={company.company_id}>
                          <ListItem 
                            button 
                            onClick={() => toggleCompanyExpand(company.company_id)}
                            sx={{ 
                              fontWeight: 'bold',
                              borderBottom: '1px solid #eee',
                              px: 2,
                              py: 1.5,
                              '&:last-child': { borderBottom: 'none' },
                              justifyContent: 'space-between',
                            }}
                          >
                            <ListItemText primary={company.company_name || '(No Name)'} />
                            {expandedCompanies[company.company_id] ? (
                              <KeyboardArrowDownIcon fontSize="small" />
                            ) : (
                              <KeyboardArrowRightIcon fontSize="small" />
                            )}
                          </ListItem>
                          {expandedCompanies[company.company_id] && (
                            <>
                              <List 
                                component="div" 
                                disablePadding 
                                sx={{ 
                                  pl: 4, 
                                  bgcolor: '#f9f9f9',
                                  borderLeft: '2px solid #ddd',
                                  borderRadius: '4px',
                                  mb: 1,
                                  boxShadow: 'inset 0 0 5px rgba(0,0,0,0.03)',
                                }}
                              >
                                {/* existing customers list */}
                                {companyCustomersLoading[company.company_id] ? (
                                  <ListItem sx={{ px: 2, py: 1 }}>
                                    <ListItemText primary="Loading customers..." />
                                  </ListItem>
                                ) : (companyCustomersMap[company.company_id]?.length > 0 ? (
                                  companyCustomersMap[company.company_id].map(cust => (
                                    <ListItem 
                                      key={cust.customer_id} 
                                      button 
                                      selected={selectedCustomer?.type === 'company' && selectedCustomer.customerId === cust.customer_id}
                                      onClick={() => handleSelectCustomer('company', cust.customer_id, company.company_id)}
                                      sx={{ pl: 2, px: 2, py: 1.5, justifyContent: 'space-between' }}
                                    >
                                      <ListItemText primary={cust.customer_name} secondary={cust.customer_email} />
                                      <EditIcon 
                                        sx={{ cursor: 'pointer' }} 
                                        onClick={e => { e.stopPropagation(); openEditCustomerDialog('company', cust, company.company_id); }} 
                                        aria-label={`Edit company customer ${cust.customer_name}`}
                                      />
                                    </ListItem>
                                  ))
                                ) : (
                                  <ListItem sx={{ px: 2, py: 1 }}>
                                    <ListItemText primary="No customers" />
                                  </ListItem>
                                ))}
                                {/* Add Customer button */}
                                <ListItem sx={{ px: 2, py: 1 }}>
                                  <Button variant="outlined" size="small" onClick={() => openAddCompanyCustomerDialog(company)}>
                                    Add Customer to Company
                                  </Button>
                                </ListItem>
                              </List>
                            </>
                          )}
                        </div>
                      ))
                    )}
                  </List>
                </Box>
              </Box>
            )}
            

          {/* Bottom bar: current customer and selected customer */}
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, pt: 2, borderTop: '1px solid #ccc', gap: 2 }}>
            <Box sx={{ flex: 1, bgcolor: 'white', p: 2, borderRadius: 2, boxShadow: 1 }}>
              <Typography variant="subtitle1" gutterBottom>Current Customer</Typography>
              <div>
                <Typography variant="body2"><strong>Name:</strong> {order.customer?.customer_name || 'N/A'}</Typography>
                <Typography variant="body2"><strong>Phone:</strong> {order.customer?.customer_number || 'N/A'}</Typography>
                <Typography variant="body2"><strong>Email:</strong> {order.customer?.customer_email || 'N/A'}</Typography>
                {order.company?.company_name && <Typography variant="body2"><strong>Company Name:</strong> {order.company.company_name}</Typography>}
                {order.company?.company_number && <Typography variant="body2"><strong>Company Phone:</strong> {order.company.company_number}</Typography>}
                {order.company?.company_email && <Typography variant="body2"><strong>Company Email:</strong> {order.company.company_email}</Typography>}
              </div>
            </Box>
            <ArrowForwardIcon sx={{ fontSize: 32, color: '#666' }} />
            <Box sx={{ flex: 1, bgcolor: 'white', p: 2, borderRadius: 2, boxShadow: 1 }}>
              <Typography variant="subtitle1" gutterBottom>Selected Customer</Typography>
              {selectedCustomer ? (
                <div>
                  {selectedCustomer.type === 'individual' && (() => {
                    const cust = individualCustomers.find(c => c.customer_id === selectedCustomer.customerId);
                    if (!cust) return <Typography variant="body2">N/A</Typography>;
                    return (
                      <>
                        <Typography variant="body2"><strong>Name:</strong> {cust.customer_name || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Phone:</strong> {cust.customer_number || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Email:</strong> {cust.customer_email || 'N/A'}</Typography>
                      </>
                    );
                  })()}
                  {selectedCustomer.type === 'company' && (() => {
                    const comp = companies.find(c => c.company_id === selectedCustomer.companyId);
                    const cust = companyCustomersMap[selectedCustomer.companyId]?.find(c => c.customer_id === selectedCustomer.customerId);
                    if (!comp || !cust) return <Typography variant="body2">N/A</Typography>;
                    return (
                      <>
                        <Typography variant="body2"><strong>Name:</strong> {cust.customer_name || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Phone:</strong> {cust.customer_number || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Email:</strong> {cust.customer_email || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Company Name:</strong> {comp.company_name || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Company Phone:</strong> {comp.company_number || 'N/A'}</Typography>
                        <Typography variant="body2"><strong>Company Email:</strong> {comp.company_email || 'N/A'}</Typography>
                      </>
                    );
                  })()}
                </div>
              ) : (
                <Typography variant="body2">None</Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCustomersDialog}>Close</Button>
          <Button 
            onClick={applySelectedCustomer} 
            variant="contained" 
            color="primary" 
            disabled={!selectedCustomer}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editCustomerDialogOpen} onClose={closeEditCustomerDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black' }}>Edit Customer</DialogTitle>
        <DialogContent>
          {editCustomerError && (
            <Typography color="error" sx={{ mb: 2 }}>{editCustomerError}</Typography>
          )}
          {editedCustomerData.customerType === 'individual' ? (
            <>
              <TextField
                label="Name"
                value={editedCustomerData.customerName}
                onChange={e => handleEditCustomerChange('customerName', e.target.value)}
                fullWidth
                margin="normal"
                required
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Phone"
                value={editedCustomerData.customerNumber}
                onChange={e => handleEditCustomerChange('customerNumber', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Email"
                value={editedCustomerData.customerEmail}
                onChange={e => handleEditCustomerChange('customerEmail', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
            </>
          ) : (
            <>
              {/* Company Info */}
              <TextField
                label="Company Name"
                value={editedCustomerData.companyName}
                onChange={e => handleEditCustomerChange('companyName', e.target.value)}
                fullWidth
                margin="normal"
                required
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Company Phone"
                value={editedCustomerData.companyNumber}
                onChange={e => handleEditCustomerChange('companyNumber', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Company Email"
                value={editedCustomerData.companyEmail}
                onChange={e => handleEditCustomerChange('companyEmail', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Company Website"
                value={editedCustomerData.companyWebsite}
                onChange={e => handleEditCustomerChange('companyWebsite', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />

              {/* Company Customer Info */}
              <TextField
                label="Customer Name"
                value={editedCustomerData.customerName}
                onChange={e => handleEditCustomerChange('customerName', e.target.value)}
                fullWidth
                margin="normal"
                required
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Customer Phone"
                value={editedCustomerData.customerNumber}
                onChange={e => handleEditCustomerChange('customerNumber', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Customer Email"
                value={editedCustomerData.customerEmail}
                onChange={e => handleEditCustomerChange('customerEmail', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditCustomerDialog} disabled={editCustomerLoading}>Cancel</Button>
          <Button onClick={handleEditCustomerSave} variant="contained" color="primary" disabled={editCustomerLoading}>
            {editCustomerLoading ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>      
      <Dialog open={addCompanyCustomerDialogOpen} onClose={closeAddCompanyCustomerDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black' }}>Add Customer to Company</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" gutterBottom>
            Company: {companyForNewCustomer?.company_name || ''}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Customer Name"
            type="text"
            fullWidth
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCompanyCustomer.customer_name}
            onChange={e => handleNewCompanyCustomerChange('customer_name', e.target.value)}
          />
          <TextField
            margin="dense"
            label="Customer Email"
            type="email"
            fullWidth
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCompanyCustomer.customer_email}
            onChange={e => handleNewCompanyCustomerChange('customer_email', e.target.value)}
          />
          <TextField
            margin="dense"
            label="Customer Phone Number"
            type="tel"
            fullWidth
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCompanyCustomer.customer_number}
            onChange={e => handleNewCompanyCustomerChange('customer_number', e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAddCompanyCustomerDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddCompanyCustomerSubmit} color="primary" variant="contained">
            Add Customer
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={createCustomerDialogOpen} onClose={closeCreateCustomerDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black' }}>
          {customerTypeToCreate === 'Company' ? 'Create Company Customer' : 'Create Individual Customer'}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Customer Name"
            fullWidth
            margin="dense"
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCustomerData.customer_name}
            onChange={e => handleNewCustomerChange('customer_name', e.target.value)}
          />
          <TextField
            label="Customer Email"
            fullWidth
            margin="dense"
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCustomerData.customer_email}
            onChange={e => handleNewCustomerChange('customer_email', e.target.value)}
          />
          <TextField
            label="Customer Phone Number"
            fullWidth
            margin="dense"
            multiline
            rows={1}
            inputProps={{ maxLength: 255 }}
            value={newCustomerData.customer_number}
            onChange={e => handleNewCustomerChange('customer_number', e.target.value)}
          />
          {customerTypeToCreate === 'Company' && (
            <>
              <TextField
                label="Company Name"
                fullWidth
                margin="dense"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
                value={newCustomerData.company_name}
                onChange={e => handleNewCustomerChange('company_name', e.target.value)}
              />
              <TextField
                label="Company Phone Number"
                fullWidth
                margin="dense"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
                value={newCustomerData.company_number}
                onChange={e => handleNewCustomerChange('company_number', e.target.value)}
              />
              <TextField
                label="Company Email"
                fullWidth
                margin="dense"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
                value={newCustomerData.company_email}
                onChange={e => handleNewCustomerChange('company_email', e.target.value)}
              />
              <TextField
                label="Company Website"
                fullWidth
                margin="dense"
                multiline
                rows={1}
                inputProps={{ maxLength: 255 }}
                value={newCustomerData.company_website}
                onChange={e => handleNewCustomerChange('company_website', e.target.value)}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCreateCustomerDialog} color="secondary">Cancel</Button>
          <Button onClick={handleCreateCustomerSubmit} color="primary" variant="contained">Create</Button>
        </DialogActions>
      </Dialog>

      {/* Duplicate Confirmation Dialog */}
      <Dialog open={duplicateDialogOpen} onClose={handleCancelDuplicate} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black' }}>Duplicate Customer Found</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Potential duplicate customers or companies were found. Do you want to continue creating this customer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDuplicate} color="secondary">Cancel</Button>
          <Button onClick={handleCreateAnyway} color="primary" variant="contained">Create Anyway</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editAddressOpen} onClose={handleCloseEditAddress} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black' }}>Edit Address</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Street Address"
            fullWidth
            multiline
            row={1}
            margin="normal"
            value={addressForm.street_address}
            onChange={handleAddressChange('street_address')}
          />
          <TextField
            label="Suburb"
            fullWidth
            multiline
            row={1}
            margin="normal"
            value={addressForm.suburb}
            onChange={handleAddressChange('suburb')}
          />
          <TextField
            label="State"
            fullWidth
            multiline
            row={1}
            margin="normal"
            value={addressForm.state}
            onChange={handleAddressChange('state')}
          />
          <TextField
            label="Postal Code"
            fullWidth
            multiline
            row={1}
            margin="normal"
            value={addressForm.postal_code}
            onChange={handleAddressChange('postal_code')}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditAddress} disabled={addressSaving}>Cancel</Button>
          <Button onClick={handleSaveAddress} disabled={addressSaving} variant="contained" color="primary">
            {addressSaving ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
  </div>
      
  );
};

export default OrderDetailDNP;